/* =========================================================
   WWC Cart Drawer JS v1.9.1
   Cart drawer state + upsells + cross-sells
========================================================= */
  

  var WWCLang = (
    document.documentElement.getAttribute('lang') ||
    (window.Shopify && Shopify.locale) ||
    'nl'
  ).slice(0, 2).toLowerCase();

  var WWCT = {
    nl: {
      discount: 'Korting',
      discountInfo: 'Meer info over korting',
      discountTipTitle: 'Woodies Kortingstip',
      discountTipText: 'Dit is je huidige korting op afgeprijsde producten. Heb je nog een kortingscode? Voeg hem toe bij afrekenen en de definitieve korting wordt berekend.',

      add: 'Toevoegen',
      adding: '…',
      busy: 'Bezig…',
      upgrade: 'Upgrade',
      upgradeFor: 'Upgrade voor',
      removeProduct: 'Verwijder product',

      freeLeftBefore: 'Nog',
      freeLeftAfter: 'tot gratis verzending',
      freeReached: '🎉 Je bestelling wordt gratis verzonden',

      tip: 'Tip',
      of: 'van',
      oftenTogether: 'Vaak samen gekozen',
      moreTips: 'Meer tips bekijken',
      previousTip: 'Vorige tip',
      nextTip: 'Volgende tip',
      changeCity: 'Wijzig plaats',
      moreInfo: 'Meer info',
      chooseCity: 'Kies plaats · ',

      cityHintMany: 'Kies de plaats voor dit extra product, of zoek een andere stad.',
      cityHintOne: 'Zoek een andere plaats.',
      cityPlaceholder: 'Andere plaats zoeken',

      cardTextHint: 'Schrijf een korte tekst voor op het houten kaartje.',
      cardTextPlaceholder: 'Bijv. Veel liefs van ons',
      cardAdd: 'Kaartje toevoegen',
      cardTextRequired: 'Vul eerst je tekst in.',

      discountSavedInit: 'Kortingscode opgeslagen. We controleren hem bij het afrekenen.',
      discountRequired: 'Vul eerst een kortingscode in.',
      discountSaved: 'Toegevoegd. De beste korting wordt straks automatisch toegepast.',
      discountRemoved: 'Kortingscode verwijderd.',

      upgradeError: 'Upgrade lukt nu niet.',
      addError: 'Toevoegen lukt nu niet. Check of dit product actief is.',
      lineMissing: 'Cart line niet gevonden',
      variantMissing: 'Geen variant gevonden: ',

      cartdealTitle: '🦫 Knaag-alert: dit is een extraatje',
      cartdealText: 'Kies eerst een skyline, klok of stadscadeau. Dan kun je deze deal gewoon meepakken.',
      cartdealCta: 'Zoek je skyline',

      addedVia: 'cart-upsell',
      belongsTo: 'Hoort bij',
      order: 'Bestelling',
      cityChoiceProperty: 'Plaatskeuze',
      cardTextProperty: 'Tekst kaartje',

      deals: {
        coasters: {
          badge: 'Vaak gekozen',
          title: 'Onderzetters erbij?',
          text: 'Set',
          previewTitle: 'Set skyline onderzetters',
          previewText: 'Maak je stadscadeau compleet met houten onderzetters. Set van 2 eiken, 2 noten en een houder. Je kiest zelf de plaats.'
        },
        breadboard: {
          badge: 'Cartdeal',
          title: 'Broodplankje erbij?',
          text: '24 × 11 cm · in geschenkverpakking',
          previewTitle: 'Exclusieve winkelwagen deal',
          previewText: 'Houten broodplankje met skyline van je stad. Leuk als extra cadeau of voor jezelf. Alleen verkrijgbaar in de winkelwagen. Afmeting: 24 x 11 x 1,5 cm. In geschenkverpakking.'
        },
        card: {
          badge: 'Cadeautip',
          title: 'Houten kaartje erbij?',
          text: 'Eigen tekst',
          previewTitle: 'Persoonlijk houten kaartje',
          previewText: 'Voeg een korte tekst toe. Mooi bij een cadeau, afscheid, jubileum of bedankje.'
        },
        batteries: {
          badge: 'Handig erbij',
          title: 'Batterijen erbij?',
          textClock: '2 stuks · meteen klaar',
          textLight: '3 stuks · voor de verlichting',
          text: '3 stuks'
        },
        light: {
          badge: 'Upgrade',
          title: 'Maak ’m extra sfeervol',
          text: 'LED-verlichting voor deze skyline'
        },
        magnet: {
          badge: 'Actie',
          title: 'Maak er een setje van',
          text: 'Kies 3 magneten en betaal er 2'
        },
        upgrade60: {
          title: 'Meer cadeaugevoel',
          text: '60 cm geeft net wat meer wow.'
        },
        upgrade100: {
          title: 'Meer stad aan de muur',
          text: '100 cm toont meer detail.'
        },
        upgrade120: {
          title: 'Echte blikvanger',
          text: '120 cm laat je stad stralen.'
        }
      }
    },

    en: {
      discount: 'Discount',
      discountInfo: 'More info about discount',
      discountTipTitle: 'Woodies discount tip',
      discountTipText: 'This is your current saving on discounted products. Have a discount code? Add it at checkout and the final discount will be calculated there.',

      add: 'Add',
      adding: '…',
      busy: 'Loading…',
      upgrade: 'Upgrade',
      upgradeFor: 'Upgrade for',
      removeProduct: 'Remove product',

      freeLeftBefore: 'Only',
      freeLeftAfter: 'away from free shipping',
      freeReached: '🎉 Your order ships for free',

      tip: 'Tip',
      of: 'of',
      oftenTogether: 'Often bought together',
      moreTips: 'View more tips',
      previousTip: 'Previous tip',
      nextTip: 'Next tip',
      changeCity: 'Change city',
      moreInfo: 'More info',
      chooseCity: 'Choose city · ',

      cityHintMany: 'Choose the city for this extra product, or search another city.',
      cityHintOne: 'Search another city.',
      cityPlaceholder: 'Search another city',

      cardTextHint: 'Write a short message for the wooden card.',
      cardTextPlaceholder: 'E.g. Lots of love from us',
      cardAdd: 'Add card',
      cardTextRequired: 'Please enter your text first.',

      discountSavedInit: 'Discount code saved. We’ll check it at checkout.',
      discountRequired: 'Please enter a discount code first.',
      discountSaved: 'Added. The best discount will be applied at checkout.',
      discountRemoved: 'Discount code removed.',

      upgradeError: 'Upgrade is not working right now.',
      addError: 'Adding this item is not working right now. Check if the product is active.',
      lineMissing: 'Cart line not found',
      variantMissing: 'No variant found: ',

      cartdealTitle: '🦫 Woody alert: this is an add-on',
      cartdealText: 'Choose a skyline, clock or city gift first. Then you can add this deal.',
      cartdealCta: 'Find your skyline',

      addedVia: 'cart-upsell',
      belongsTo: 'Belongs to',
      order: 'Order',
      cityChoiceProperty: 'City choice',
      cardTextProperty: 'Card text',

      deals: {
        coasters: {
          badge: 'Popular pick',
          title: 'Add coasters?',
          text: 'Set',
          previewTitle: 'Skyline coaster set',
          previewText: 'Complete your city gift with wooden coasters. Set of 2 oak, 2 walnut and a holder. You choose the city.'
        },
        breadboard: {
          badge: 'Cart deal',
          title: 'Add a bread board?',
          text: '24 × 11 cm · gift packed',
          previewTitle: 'Exclusive cart deal',
          previewText: 'Wooden bread board with the skyline of your city. Great as an extra gift or for yourself. Only available in the cart. Size: 24 x 11 x 1.5 cm. Gift packed.'
        },
        card: {
          badge: 'Gift tip',
          title: 'Add a wooden card?',
          text: 'Your own text',
          previewTitle: 'Personal wooden card',
          previewText: 'Add a short message. Great for a gift, farewell, anniversary or thank-you.'
        },
        batteries: {
          badge: 'Useful add-on',
          title: 'Add batteries?',
          textClock: '2 pieces · ready to go',
          textLight: '3 pieces · for the lighting',
          text: '3 pieces'
        },
        light: {
          badge: 'Upgrade',
          title: 'Add extra atmosphere',
          text: 'LED lighting for this skyline'
        },
        magnet: {
          badge: 'Deal',
          title: 'Make it a set',
          text: 'Choose 3 magnets, pay for 2'
        },
        upgrade60: {
          title: 'More gift impact',
          text: '60 cm adds extra wow.'
        },
        upgrade100: {
          title: 'More city on your wall',
          text: '100 cm shows more detail.'
        },
        upgrade120: {
          title: 'A true eye-catcher',
          text: '120 cm makes your city shine.'
        }
      }
    },

    de: {
      discount: 'Rabatt',
      discountInfo: 'Mehr Infos zum Rabatt',
      discountTipTitle: 'Woodies Rabatt-Tipp',
      discountTipText: 'Das ist dein aktueller Vorteil auf reduzierte Produkte. Hast du einen Rabattcode? Gib ihn beim Bezahlen ein. Der endgültige Rabatt wird dort berechnet.',

      add: 'Hinzufügen',
      adding: '…',
      busy: 'Lädt…',
      upgrade: 'Upgrade',
      upgradeFor: 'Upgrade für',
      removeProduct: 'Produkt entfernen',

      freeLeftBefore: 'Noch',
      freeLeftAfter: 'bis zum kostenlosen Versand',
      freeReached: '🎉 Deine Bestellung wird kostenlos versendet',

      tip: 'Tipp',
      of: 'von',
      oftenTogether: 'Oft zusammen gewählt',
      moreTips: 'Mehr Tipps ansehen',
      previousTip: 'Vorheriger Tipp',
      nextTip: 'Nächster Tipp',
      changeCity: 'Stadt ändern',
      moreInfo: 'Mehr Infos',
      chooseCity: 'Stadt wählen · ',

      cityHintMany: 'Wähle die Stadt für dieses Extra oder suche eine andere Stadt.',
      cityHintOne: 'Suche eine andere Stadt.',
      cityPlaceholder: 'Andere Stadt suchen',

      cardTextHint: 'Schreibe einen kurzen Text für die Holzkarte.',
      cardTextPlaceholder: 'Z. B. Alles Liebe von uns',
      cardAdd: 'Karte hinzufügen',
      cardTextRequired: 'Bitte gib zuerst deinen Text ein.',

      discountSavedInit: 'Rabattcode gespeichert. Wir prüfen ihn beim Bezahlen.',
      discountRequired: 'Bitte gib zuerst einen Rabattcode ein.',
      discountSaved: 'Hinzugefügt. Der beste Rabatt wird beim Bezahlen angewendet.',
      discountRemoved: 'Rabattcode entfernt.',

      upgradeError: 'Upgrade klappt gerade nicht.',
      addError: 'Hinzufügen klappt gerade nicht. Prüfe, ob das Produkt aktiv ist.',
      lineMissing: 'Warenkorbzeile nicht gefunden',
      variantMissing: 'Keine Variante gefunden: ',

      cartdealTitle: '🦫 Woody-Hinweis: Das ist ein Extra',
      cartdealText: 'Wähle zuerst eine Skyline, Uhr oder ein Stadtgeschenk. Danach kannst du diesen Deal hinzufügen.',
      cartdealCta: 'Skyline suchen',

      addedVia: 'cart-upsell',
      belongsTo: 'Gehört zu',
      order: 'Bestellung',
      cityChoiceProperty: 'Stadtwahl',
      cardTextProperty: 'Kartentext',

      deals: {
        coasters: {
          badge: 'Oft gewählt',
          title: 'Untersetzer dazu?',
          text: 'Set',
          previewTitle: 'Skyline-Untersetzer-Set',
          previewText: 'Mach dein Stadtgeschenk komplett mit Holzuntersetzern. Set aus 2 Eiche, 2 Nussbaum und einem Halter. Du wählst die Stadt.'
        },
        breadboard: {
          badge: 'Warenkorb-Deal',
          title: 'Brotschneidebrett dazu?',
          text: '24 × 11 cm · in Geschenkverpackung',
          previewTitle: 'Exklusiver Warenkorb-Deal',
          previewText: 'Holzbrett mit der Skyline deiner Stadt. Schön als Extra-Geschenk oder für dich selbst. Nur im Warenkorb erhältlich. Größe: 24 x 11 x 1,5 cm. In Geschenkverpackung.'
        },
        card: {
          badge: 'Geschenktipp',
          title: 'Holzkarte dazu?',
          text: 'Eigener Text',
          previewTitle: 'Persönliche Holzkarte',
          previewText: 'Füge einen kurzen Text hinzu. Schön für Geschenk, Abschied, Jubiläum oder Dankeschön.'
        },
        batteries: {
          badge: 'Praktisch dazu',
          title: 'Batterien dazu?',
          textClock: '2 Stück · sofort startklar',
          textLight: '3 Stück · für die Beleuchtung',
          text: '3 Stück'
        },
        light: {
          badge: 'Upgrade',
          title: 'Mach sie stimmungsvoller',
          text: 'LED-Beleuchtung für diese Skyline'
        },
        magnet: {
          badge: 'Aktion',
          title: 'Mach ein Set daraus',
          text: 'Wähle 3 Magnete und zahle 2'
        },
        upgrade60: {
          title: 'Mehr Geschenkgefühl',
          text: '60 cm sorgt für mehr Wow.'
        },
        upgrade100: {
          title: 'Mehr Stadt an der Wand',
          text: '100 cm zeigt mehr Details.'
        },
        upgrade120: {
          title: 'Echter Blickfang',
          text: '120 cm lässt deine Stadt strahlen.'
        }
      }
    },

    fr: {
      discount: 'Réduction',
      discountInfo: 'Plus d’infos sur la réduction',
      discountTipTitle: 'Conseil réduction Woodies',
      discountTipText: 'Voici ta réduction actuelle sur les produits remisés. Tu as un code promo ? Ajoute-le au paiement. La réduction finale sera calculée là-bas.',

      add: 'Ajouter',
      adding: '…',
      busy: 'Chargement…',
      upgrade: 'Upgrade',
      upgradeFor: 'Upgrade pour',
      removeProduct: 'Supprimer le produit',

      freeLeftBefore: 'Encore',
      freeLeftAfter: 'pour la livraison gratuite',
      freeReached: '🎉 Ta commande sera livrée gratuitement',

      tip: 'Conseil',
      of: 'sur',
      oftenTogether: 'Souvent choisi ensemble',
      moreTips: 'Voir plus de conseils',
      previousTip: 'Conseil précédent',
      nextTip: 'Conseil suivant',
      changeCity: 'Changer la ville',
      moreInfo: 'Plus d’infos',
      chooseCity: 'Choisis la ville · ',

      cityHintMany: 'Choisis la ville pour ce produit en plus, ou cherche une autre ville.',
      cityHintOne: 'Cherche une autre ville.',
      cityPlaceholder: 'Chercher une autre ville',

      cardTextHint: 'Écris un court texte pour la carte en bois.',
      cardTextPlaceholder: 'Ex. Avec tout notre amour',
      cardAdd: 'Ajouter la carte',
      cardTextRequired: 'Ajoute d’abord ton texte.',

      discountSavedInit: 'Code promo enregistré. Nous le vérifierons au paiement.',
      discountRequired: 'Ajoute d’abord un code promo.',
      discountSaved: 'Ajouté. La meilleure réduction sera appliquée au paiement.',
      discountRemoved: 'Code promo supprimé.',

      upgradeError: 'L’upgrade ne fonctionne pas pour le moment.',
      addError: 'L’ajout ne fonctionne pas pour le moment. Vérifie si le produit est actif.',
      lineMissing: 'Ligne du panier introuvable',
      variantMissing: 'Aucune variante trouvée : ',

      cartdealTitle: '🦫 Alerte Woody : c’est un extra',
      cartdealText: 'Choisis d’abord une skyline, une horloge ou un cadeau de ville. Ensuite, tu peux ajouter cette offre.',
      cartdealCta: 'Trouver ta skyline',

      addedVia: 'cart-upsell',
      belongsTo: 'Appartient à',
      order: 'Commande',
      cityChoiceProperty: 'Ville choisie',
      cardTextProperty: 'Texte de la carte',

      deals: {
        coasters: {
          badge: 'Souvent choisi',
          title: 'Ajouter des dessous de verre ?',
          text: 'Set',
          previewTitle: 'Set de dessous de verre skyline',
          previewText: 'Complète ton cadeau de ville avec des dessous de verre en bois. Set de 2 chêne, 2 noyer et un support. Tu choisis la ville.'
        },
        breadboard: {
          badge: 'Offre panier',
          title: 'Ajouter une planchette ?',
          text: '24 × 11 cm · emballage cadeau',
          previewTitle: 'Offre exclusive panier',
          previewText: 'Planchette en bois avec la skyline de ta ville. Sympa comme cadeau en plus ou pour toi. Disponible seulement dans le panier. Format : 24 x 11 x 1,5 cm. Emballage cadeau.'
        },
        card: {
          badge: 'Idée cadeau',
          title: 'Ajouter une carte en bois ?',
          text: 'Ton propre texte',
          previewTitle: 'Carte en bois personnalisée',
          previewText: 'Ajoute un court texte. Parfait pour un cadeau, un départ, un anniversaire ou un remerciement.'
        },
        batteries: {
          badge: 'Pratique',
          title: 'Ajouter des piles ?',
          textClock: '2 piles · prêtes à l’emploi',
          textLight: '3 piles · pour l’éclairage',
          text: '3 pièces'
        },
        light: {
          badge: 'Upgrade',
          title: 'Ajoute plus d’ambiance',
          text: 'Éclairage LED pour cette skyline'
        },
        magnet: {
          badge: 'Offre',
          title: 'Fais-en un set',
          text: 'Choisis 3 magnets, paie 2'
        },
        upgrade60: {
          title: 'Plus d’effet cadeau',
          text: '60 cm ajoute un vrai wow.'
        },
        upgrade100: {
          title: 'Plus de ville au mur',
          text: '100 cm montre plus de détails.'
        },
        upgrade120: {
          title: 'Vrai point fort',
          text: '120 cm fait briller ta ville.'
        }
      }
    }
  };

  var T = WWCT[WWCLang] || WWCT.nl;





(function () {
  if (window.WWCCartDrawerV191) return;
  window.WWCCartDrawerV191 = true;

  var WWC = {
    drawerSelector: '#CartDrawer',
    cityIndexUrl: '/pages/alle-steden?view=wwc-city-index',
    magnetCollectionUrl: '/collections/magneten',
    freeShippingThreshold: 5000,

    enabled: {
      /* MAAT-UPGRADE UIT (16 aug 2026).

         Deze bood in de winkelwagen een grotere maat aan van het product dat
         er net in was gelegd. Twee redenen om hem uit te zetten:

         1. In een jaar tijd drie keer gebruikt.
         2. Hij spreekt de keuze tegen die de klant net heeft gemaakt. Op de
            productpagina staan de maten inmiddels met prijs naast elkaar en
            is er een maatadvies; wie dan 80 cm kiest heeft dat gewogen. Daar
            in de winkelwagen op terugkomen leest als twijfel zaaien over een
            beslissing die al genomen is.

         De winkelwagen richt zich op CROSS-SELLS en aanvullingen (onderzetters,
         broodplank, batterijen) - dingen die de bestelling aanvullen in plaats
         van vervangen.

         Op true zetten brengt hem terug; de code eronder is ongemoeid. */
      sizeUpgrade: false,
      lightCrossSell: false,
      woodenCard: false,
      coasters: true,   /* WWC dealsysteem ronde 25/27: aan, alleen zonder set in de mand (zie wdUpsellMag); sinds ronde 27 ook na 19 okt */
      breadboard: true,   /* WWC dealsysteem ronde 25: idem */
      batteries: true,
      magnets: false,
      sortAddonsToBottom: false,
      removeButtons: true
    },

    materials: [
      { slug: 'black-acrylic', label: 'Zwart glanzend' },
      { slug: 'white-acrylic', label: 'Wit glanzend' },
      { slug: 'gold-acrylic', label: 'Goud metallic' },
      { slug: 'mirror-acrylic', label: 'Spiegel' },
      { slug: 'palissander', label: 'Palissander' },
      { slug: 'bamboe', label: 'Bamboe' },
      { slug: 'eiken', label: 'Eiken' },
      { slug: 'noten', label: 'Noten' },
      { slug: 'black', label: 'Zwart' }
    ],

    deals: {
      coasters: {
        id: 'coasters',
        badge: T.deals.coasters.badge,
        emoji: '🍽️',
        handle: 'cartdeal-skyline-onderzetters',
        sku: 'cartdeal-skyline-onderzetters-eiken-noten',
        title: T.deals.coasters.title,
        text: T.deals.coasters.text,
        oldPrice: '€19,95',
        price: '€14,95',
        repeatable: true,
        needsCity: true,
        previewTitle: T.deals.coasters.previewTitle,
        previewText: T.deals.coasters.previewText
      },

      breadboard: {
        id: 'breadboard',
        badge: T.deals.breadboard.badge,
        emoji: '🎁',
        handle: 'cartdeal-skyline-broodplankje',
        sku: 'cartdeal-skyline-broodplankje',
        title: T.deals.breadboard.title,
        text: T.deals.breadboard.text,
        oldPrice: '€19,95',
        price: '€14,95',
        repeatable: true,
        needsCity: true,
        previewTitle: T.deals.breadboard.previewTitle,
        previewText: T.deals.breadboard.previewText
      },

      card: {
        id: 'card',
        badge: T.deals.card.badge,
        emoji: '💌',
        handle: 'cartdeal-houten-kaartje',
        sku: 'cartdeal-houten-kaartje',
        title: T.deals.card.title,
        text: T.deals.card.text,
        oldPrice: '€5,95',
        price: '€4,95',
        needsText: true,
        previewTitle: T.deals.card.previewTitle,
        previewText: T.deals.card.previewText
      },

      batteries: {
        id: 'batteries',
        badge: T.deals.batteries.badge,
        emoji: '🔋',
        handle: 'duracell-procell-aa-batterijen',
        /* WWC dealsysteem ronde 28 (besluit Freek 11 okt): het echte product (gelezen in Shopify 11 okt), toevoegen op variant-id.
           Bij een klok 2 stuks; bij verlichting (ook klok + verlichting) 3 stuks. Zie batterijAanbod. */
        variants: {
          twee: { variantId: 39359751454917, sku: 'duracell-procell-aa-batterijen-2stuks', oldPrice: '€3,95', price: '€2,95' },
          drie: { variantId: 60779417796942, sku: 'duracell-procell-aa-batterijen-3stuks', oldPrice: '€5,95', price: '€3,95' }
        },
        teksten: { klok: T.deals.batteries.textClock, licht: T.deals.batteries.textLight },
        title: T.deals.batteries.title,
        text: T.deals.batteries.textClock
      },

      light: {
        id: 'light',
        badge: T.deals.light.badge,
        emoji: '💡',
        handle: 'met-verlichting',
        sku: 'led-verlichting-combinatie-met-wanddecoratie',
        title: T.deals.light.title,
        text: T.deals.light.text,
        price: '€30',
        attachToItem: true
      }
    }
  };

  var productCache = {};
  var variantCache = {};
  var cityCache = null;
  var cityPromise = null;
  var cartCache = null;

  var renderTimer = null;
  var refreshTimer = null;
  var lateRefreshTimer = null;
  var refreshController = null;

  var busy = false;
  var suppressObserver = false;
  var lastCartSignature = '';

  function drawer() {
    return document.querySelector(WWC.drawerSelector);
  }

  function root() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function endpoint(path) {
    return root().replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  function getJson(url, options) {
    return fetch(url, options || { credentials: 'same-origin', cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('Request failed: ' + url);
      return res.json();
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed');
      return res.json();
    });
  }

  function getCart(force) {
    if (cartCache && !force) return Promise.resolve(cartCache);

    return getJson(endpoint('/cart.js') + '?_wwc=' + Date.now()).then(function (cart) {
      cartCache = cart;
      return cart;
    });
  }

  function clearCartCache() {
    cartCache = null;
  }

  function loadProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = getJson(endpoint('/products/' + handle + '.js')).catch(function (err) {
      delete productCache[handle];
      throw err;
    });

    return productCache[handle];
  }


  function parseMoneyToCents(value) {
    var clean = String(value || '')
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var number = parseFloat(clean);

    if (isNaN(number)) return 0;

    return Math.round(number * 100);
  }

  function updateFooterDiscounts(cart) {
    var d = drawer();
    if (!d || !cart) return;

    var wrap = d.querySelector('[data-discounts]');
    if (!wrap) return;

    var cartDiscountTotal = 0;
    var cartDiscountTitles = [];

    (cart.cart_level_discount_applications || []).forEach(function (discount) {
      var amount = Number(discount.total_allocated_amount || 0);

      if (amount > 0) {
        cartDiscountTotal += amount;

        if (discount.title && cartDiscountTitles.indexOf(discount.title) === -1) {
          cartDiscountTitles.push(discount.title);
        }
      }
    });

    /*
      WWC korting berekening:
      - Basis = oude prijs als die zichtbaar is in de cart line
      - Anders = originele line price uit cart.js
      - Eindprijs = cart.total_price
      Zo tellen sale + kortingscode netjes samen op.
    */

    var baselineTotal = 0;
    var cartItemsByKey = {};

    (cart.items || []).forEach(function (item) {
      if (item.key) cartItemsByKey[item.key] = item;
    });

    d.querySelectorAll('[data-products] .cart__item[data-key]').forEach(function (lineNode) {
      var key = lineNode.getAttribute('data-key');
      var item = cartItemsByKey[key];

      if (!item) return;

      var oldPriceNode = lineNode.querySelector('.cart__price--strikethrough, .cart__price--compare');
      var oldPrice = oldPriceNode ? parseMoneyToCents(oldPriceNode.textContent) : 0;

      if (oldPrice > 0) {
        baselineTotal += oldPrice;
        return;
      }

      baselineTotal += Number(item.original_line_price || item.line_price || item.final_line_price || 0);
    });

    if (baselineTotal <= 0) {
      baselineTotal = Number(cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0);
    }

    var totalSavings = Math.max(0, baselineTotal - Number(cart.total_price || 0));

    if (totalSavings <= 0) {
      wrap.innerHTML = '';
      return;
    }

    var discountTitle = cartDiscountTitles.length ? cartDiscountTitles.join(', ') : '';

    wrap.innerHTML = [
      '<div class="cart__item-sub cart__item-row wwc-cart-footer__discount-row">',
        '<div class="wwc-cart-footer__discount-label">',
          '<span>' + escapeHtml(T.discount) + '</span>',
          discountTitle ? '<small>' + escapeHtml(discountTitle) + '</small>' : '',
          !discountTitle ? [
            '<button type="button" class="wwc-cart-footer__discount-info" data-wwc-footer-discount-info aria-label="' + escapeHtml(T.discountInfo) + '">i</button>'
          ].join('') : '',
        '</div>',
        '<div class="wwc-cart-footer__discount-price">-' + formatMoney(totalSavings) + '</div>',
      '</div>',
      !discountTitle ? [
        '<div class="wwc-cart-footer__discount-note" data-wwc-footer-discount-note hidden>',
          '<strong>Woodies Kortingstip</strong>',
          '<span>Dit is je huidige korting op afgeprijsde producten. Heb je nog een kortingscode? Voeg hem toe bij afrekenen en de definitieve korting wordt berekend.</span>',
        '</div>'
      ].join('') : ''
    ].join('');
  }

  function getVariant(handle, sku) {
    var cacheKey = handle + '|' + String(sku || '').toLowerCase();
    if (variantCache[cacheKey]) return Promise.resolve(variantCache[cacheKey]);

    return loadProduct(handle).then(function (product) {
      var variants = product.variants || [];
      var variant = null;

      if (sku) {
        variant = variants.find(function (v) {
          return String(v.sku || '').toLowerCase() === String(sku).toLowerCase();
        });
      }

      if (!variant) {
        variant = variants.find(function (v) {
          return v.available !== false;
        });
      }

      if (!variant || variant.available === false) {
        throw new Error('Geen variant gevonden: ' + handle);
      }

      variantCache[cacheKey] = variant;
      return variant;
    });
  }

  function loadCities() {
    if (cityCache) return Promise.resolve(cityCache);
    if (cityPromise) return cityPromise;

    cityPromise = getJson(endpoint(WWC.cityIndexUrl)).then(function (data) {
      cityCache = Array.isArray(data.items) ? data.items : [];
      return cityCache;
    }).catch(function () {
      cityCache = [];
      return cityCache;
    });

    return cityPromise;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[m];
    });
  }

  function cssEscape(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value || '').replace(/"/g, '\\"');
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' en ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function itemCase(value) {
    return String(value || '').replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  function formatMoney(cents) {
    var value = Math.max(0, Number(cents || 0)) / 100;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return '€' + value.toFixed(2).replace('.', ',');
    /* WWC ronde 29: andere valuta zoals Shopify ze in die markt schrijft ($59.00, £59.00); de mand rekent dan al in die valuta */
    try { return new Intl.NumberFormat({ USD: 'en-US', GBP: 'en-GB', CAD: 'en-CA' }[cur] || document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(value); }
    catch (e) { return cur + ' ' + value.toFixed(2); }
  }

  function parseMoneyToCents(value) {
    var clean = String(value || '')
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var amount = parseFloat(clean);

    if (isNaN(amount)) return 0;

    return Math.round(amount * 100);
  }

  function eurosOnly(cents) {
    var value = Math.max(0, Number(cents || 0)) / 100;
    return value.toLocaleString('nl-NL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function sessionKey() {
    return 'wwc_cart_upsell_hidden_v191';
  }

  function globalIndexKey() {
    return 'wwc_cart_upsell_global_index_v191';
  }

  function getHiddenOffers() {
    try {
      return JSON.parse(sessionStorage.getItem(sessionKey()) || '[]');
    } catch (e) {
      return [];
    }
  }

  function hideOffer(key) {
    if (!key) return;

    var hidden = getHiddenOffers();
    if (hidden.indexOf(key) === -1) hidden.push(key);

    try {
      sessionStorage.setItem(sessionKey(), JSON.stringify(hidden));
    } catch (e) {}
  }

  function clearHiddenOffers() {
    try {
      sessionStorage.removeItem(sessionKey());
    } catch (e) {}
  }

  function isOfferHidden(key) {
    return getHiddenOffers().indexOf(key) !== -1;
  }

  function setHiddenOffers(hidden) {
    try {
      sessionStorage.setItem(sessionKey(), JSON.stringify(hidden || []));
    } catch (e) {}
  }

  function isGlobalOfferKey(key) {
    return String(key || '').indexOf('global:') === 0;
  }

  function getHiddenGlobalOfferKeys() {
    return getHiddenOffers().filter(isGlobalOfferKey);
  }

  function clearHiddenGlobalOffers() {
    var keep = getHiddenOffers().filter(function (key) {
      return !isGlobalOfferKey(key);
    });

    setHiddenOffers(keep);
  }

  function getGlobalIndex() {
    try {
      return Number(sessionStorage.getItem(globalIndexKey()) || 0);
    } catch (e) {
      return 0;
    }
  }

  function setGlobalIndex(index) {
    try {
      sessionStorage.setItem(globalIndexKey(), String(index));
    } catch (e) {}
  }

  function clampGlobalIndex(index, total) {
    if (!total) return 0;
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
  }

  function stripMaterial(slug) {
    var out = String(slug || '');

    WWC.materials.forEach(function (mat) {
      var suffix = '-' + mat.slug;
      if (out.endsWith(suffix)) out = out.slice(0, -suffix.length);
    });

    return out;
  }

  function inferCitySlug(handle) {
    var h = String(handle || '');

    h = h.replace(/^standing-skyline-/, '');
    h = h.replace(/^skyline-klok-rond-/, '');
    h = h.replace(/^skyline-klok-/, '');
    h = h.replace(/^skyline-/, '');

    return stripMaterial(h);
  }

  function findCityNameFromSlug(citySlug) {
    if (!citySlug) return '';

    if (!cityCache || !Array.isArray(cityCache)) {
      return itemCase(citySlug.replace(/-/g, ' '));
    }

    var match = cityCache.find(function (item) {
      return slugify(item.plaats) === citySlug || String(item.handle || '').indexOf(citySlug) !== -1;
    });

    return match ? itemCase(match.plaats) : itemCase(citySlug.replace(/-/g, ' '));
  }

  /* WWC dealsysteem ronde 33: het producttype terug in het Nederlands, in kleine letters (in het Engels vertaalt Shopify het: Clock → klok) */
  function wdTypeNL(t) { var l = String(t == null ? '' : t).toLowerCase().trim(); return ({ 'clock': 'klok', 'accessories': 'accessoires', 'magnet': 'magneet', 'tapas board': 'tapasplank', 'phone holder': 'telefoonhouder', 'coasters': 'onderzetters', 'gift set': 'cadeauset', 'keychain': 'sleutelhanger', 'geometric animals': 'geometrische dieren', 'province': 'provincie', 'world map': 'wereldkaart', 'modification': 'modificatie', 'map': 'landkaart', 'city map': 'citymap', 'key holder': 'sleutelhouder' })[l] || l; }

  function inferKind(data) {
    var handle = String(data.handle || '').toLowerCase();
    var type = wdTypeNL(data.type);   /* WWC dealsysteem ronde 33 */
    var title = String(data.title || '').toLowerCase();

    if (handle.indexOf('standing-skyline-') === 0 || title.indexOf('standing') !== -1) return 'standing';
    if (handle.indexOf('skyline-klok-rond-') === 0 || (type === 'klok' && title.indexOf('rond') !== -1)) return 'clock-round';
    if (handle.indexOf('skyline-klok-') === 0 || type === 'klok') return 'clock-half';
    if (type === 'magneet' || handle.indexOf('magneet') !== -1) return 'magnet';
    if (type === 'skyline' || handle.indexOf('skyline-') === 0) return 'wall';

    return 'general';
  }

  function inferSize(sku) {
    var s = String(sku || '').toLowerCase();

    if (s.indexOf('40cm') !== -1) return '40';
    if (s.indexOf('60cm') !== -1) return '60';
    if (s.indexOf('80cm') !== -1) return '80';
    if (s.indexOf('100cm') !== -1) return '100';
    if (s.indexOf('120cm') !== -1) return '120';

    return '';
  }

  function getData(el) {
    return {
      key: el.getAttribute('data-line-key') || '',
      title: el.getAttribute('data-line-title') || '',
      handle: el.getAttribute('data-product-handle') || '',
      type: el.getAttribute('data-product-type') || '',
      sku: el.getAttribute('data-variant-sku') || '',
      qty: Number(el.getAttribute('data-line-qty') || 1),
      city: el.getAttribute('data-line-city') || ''
    };
  }

  function getDomCityByKey(key) {
    if (!key) return '';

    var el = document.querySelector('[data-wwc-cart-upsell][data-line-key="' + cssEscape(key) + '"]');
    return el ? el.getAttribute('data-line-city') || '' : '';
  }

  function isAddonProductData(data) {
    var handle = String(data.handle || '').toLowerCase();
    var title = String(data.title || '').toLowerCase();
    var type = wdTypeNL(data.type);   /* WWC dealsysteem ronde 33 */

    return (
      handle.indexOf('cartdeal-') === 0 ||
      handle === 'met-verlichting' ||
      handle.indexOf('houten-kaartje') !== -1 ||
      handle.indexOf('duracell') !== -1 ||
      handle.indexOf('batterijen') !== -1 ||
      handle.indexOf('serveerplank') !== -1 ||
      handle.indexOf('onderzetters') !== -1 ||
      handle.indexOf('broodplankje') !== -1 ||
      title.indexOf('met verlichting') !== -1 ||
      title.indexOf('serveerplank') !== -1 ||
      title.indexOf('onderzetters') !== -1 ||
      title.indexOf('broodplankje') !== -1 ||
      type === 'tapasplank' ||
      type === 'onderzetters'
    );
  }

  function isAddonCartItem(item) {
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();

    return (
      handle.indexOf('cartdeal-') === 0 ||
      handle === 'met-verlichting' ||
      handle === WWC.deals.batteries.handle ||
      handle.indexOf('duracell') !== -1 ||
      handle.indexOf('batterijen') !== -1 ||
      title.indexOf('duracell') !== -1 ||
      title.indexOf('batterijen') !== -1
    );
  }

  function itemExistsInCart(cart, handle) {
    return !!((cart.items || []).find(function (item) {
      return item.handle === handle;
    }));
  }

  function propValueIsYes(value) {
    var v = String(value || '').toLowerCase().trim();

    if (!v) return false;
    if (v.indexOf('zonder') !== -1) return false;
    if (v === 'nee' || v === 'no' || v === 'false' || v === '0') return false;

    return (
      v.indexOf('met verlichting') !== -1 ||
      v === 'ja' ||
      v === 'yes' ||
      v === 'true' ||
      v === 'gekozen'
    );
  }

  function lineHasLight(line) {
    if (!line || !line.properties) return false;

    return ['Met verlichting', 'met verlichting', 'Verlichting', 'verlichting'].some(function (key) {
      return propValueIsYes(line.properties[key]);
    });
  }

  function cartHasLight(cart) {
    return itemExistsInCart(cart, WWC.deals.light.handle) || (cart.items || []).some(lineHasLight);
  }

  /* WWC dealsysteem ronde 28: elke variant van het echte product telt (ook 1 en 10 stuks), op handle, variant-id of sku */
  function cartHasBatteries(cart) {
    var b = WWC.deals.batteries;
    var ids = Object.keys(b.variants || {}).map(function (k) { return Number(b.variants[k].variantId); });
    return (cart.items || []).some(function (item) {
      var props = item.properties || {};
      var h = String(item.handle || '').toLowerCase();
      return h === b.handle || h === 'cartdeal-' + b.handle ||
        ids.indexOf(Number(item.variant_id || item.id)) !== -1 ||
        String(item.sku || '').toLowerCase().indexOf(b.handle) === 0 ||
        !!(props.Batterijen || props.batterijen);
    });
  }

  /* WWC dealsysteem ronde 28 (besluit Freek 11 okt): bij verlichting in de mand (ook met een klok) 3 stuks, anders (klok) 2 stuks */
  function batterijAanbod(klok, licht) {
    var b = WWC.deals.batteries, v = licht ? b.variants.drie : b.variants.twee;
    return Object.assign({}, b, {
      variantId: v.variantId,
      sku: v.sku,
      oldPrice: v.oldPrice,
      price: v.price,
      text: licht ? b.teksten.licht : b.teksten.klok
    });
  }

  function getProductImage(product) {
    if (!product) return '';
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

    function buildUpgrade(data) {
      var kind = inferKind(data);
      var size = inferSize(data.sku);

      if (kind === 'standing' && size === '40') {
        return {
          id: 'upgrade-60',
          emoji: '✨',
          title: T.deals.upgrade60.title,
          text: T.deals.upgrade60.text,
          targetHandle: data.handle,
          targetSku: data.sku.replace('40cm', '60cm'),
          from: '40cm',
          to: '60cm'
        };
      }

      if (kind === 'wall' && size === '80') {
        return {
          id: 'upgrade-100',
          emoji: '✨',
          title: T.deals.upgrade100.title,
          text: T.deals.upgrade100.text,
          targetHandle: data.handle,
          targetSku: data.sku.replace('80cm', '100cm'),
          from: '80cm',
          to: '100cm'
        };
      }

      if (kind === 'wall' && size === '100') {
        return {
          id: 'upgrade-120',
          emoji: '✨',
          title: T.deals.upgrade120.title,
          text: T.deals.upgrade120.text,
          targetHandle: data.handle,
          targetSku: data.sku.replace('100cm', '120cm'),
          from: '100cm',
          to: '120cm'
        };
      }

      return null;
    }

  function getItemOfferKey(data, item) {
    return ['item', item.id, data.key || data.handle].join(':');
  }

  function getGlobalOfferKey(item) {
    return ['global', item.id || item.custom || 'offer'].join(':');
  }

  function buildItemNudge(data, cart) {
    if (isAddonProductData(data)) return null;

    var line = (cart.items || []).find(function (item) {
      return item.key === data.key;
    });

    var alreadyUpgraded = !!(
      line &&
      line.properties &&
      String(line.properties._wwc_upgrade || '') === 'true'
    );

    if (WWC.enabled.sizeUpgrade && !alreadyUpgraded) {
      var upgrade = buildUpgrade(data);

      if (upgrade && !isOfferHidden(getItemOfferKey(data, upgrade))) {
        return { item: upgrade, type: 'upgrade' };
      }
    }

    if (
      WWC.enabled.lightCrossSell &&
      inferKind(data) === 'wall' &&
      line &&
      !lineHasLight(line) &&
      !itemExistsInCart(cart, WWC.deals.light.handle)
    ) {
      var light = WWC.deals.light;

      if (!isOfferHidden(getItemOfferKey(data, light))) {
        return { item: light, type: 'item-crosssell' };
      }
    }

    return null;
  }

  function getMainCartItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !isAddonCartItem(item);
    });
  }

  function getCartCities(cart) {
    var seen = {};
    var cities = [];

    getMainCartItems(cart).forEach(function (item) {
      var cityName = '';

      if (item.properties && item.properties.Plaatskeuze) {
        cityName = item.properties.Plaatskeuze;
      }

      if (!cityName) cityName = getDomCityByKey(item.key);
      if (!cityName) cityName = findCityNameFromSlug(inferCitySlug(item.handle));

      if (cityName && !seen[slugify(cityName)]) {
        seen[slugify(cityName)] = true;
        cities.push(cityName);
      }
    });

    return cities;
  }

  function withAddedState(deal, cart) {
    var copy = Object.assign({}, deal);
    copy.added = !!(deal.handle && itemExistsInCart(cart, deal.handle));
    return copy;
  }

  function buildGlobalDeals(cart, ignoreHidden) {
    var items = getMainCartItems(cart);

    var hasClock = items.some(function (item) {
      /* WWC dealsysteem ronde 11 (marketing O1): een klok in een Cadeauset telt ook */
      if (wdTypeNL(item.product_type) === 'cadeauset') {
        var wdp = item.properties || {};
        if (Object.keys(wdp).some(function (k) { return /^klok( |$)/i.test(k) && wdp[k]; })) return true;
        return (item.item_components || item.components || []).some(function (c) { return inferKind({ handle: c.handle, title: c.product_title || c.title, type: c.product_type, sku: c.sku }).indexOf('clock') === 0; });
      }
      return inferKind({
        handle: item.handle,
        title: item.product_title,
        type: item.product_type,
        sku: item.sku
      }).indexOf('clock') === 0;
    });

    var hasMagnet = items.some(function (item) {
      return inferKind({
        handle: item.handle,
        title: item.product_title,
        type: item.product_type,
        sku: item.sku
      }) === 'magnet';
    });

    var primary = [];
    var back = [];

    if (WWC.enabled.batteries && (hasClock || cartHasLight(cart)) && !cartHasBatteries(cart)) {
      primary.push(batterijAanbod(hasClock, cartHasLight(cart)));
    }

    if (WWC.enabled.magnets && hasMagnet) {
      primary.push({
        id: 'magnet-action',
        badge: T.deals.magnet.badge,
        emoji: '🧲',
        custom: 'magnet',
        title: T.deals.magnet.title,
        text: T.deals.magnet.text
      });
    }

    /* WWC dealsysteem ronde 25 (besluit Freek): broodplankje en onderzetters alleen zonder set in de mand. Ronde 27 (besluit Freek 10 okt):
       geen datumgrens meer, ook in de stapelperiode (vanaf 19 okt) aan */
    var wdUpsellMag = !((cart && cart.items) || []).some(function (it) { var wp = it.properties || {}; return wdTypeNL(it.product_type) === 'cadeauset' || !!wp._wwc_deal || !!wp._wwc_deal_set; });
    if (WWC.enabled.breadboard && wdUpsellMag) {
      var bread = withAddedState(WWC.deals.breadboard, cart);
      (bread.added ? back : primary).push(bread);
    }

    if (WWC.enabled.coasters && wdUpsellMag) {
      var coasters = withAddedState(WWC.deals.coasters, cart);
      (coasters.added ? back : primary).push(coasters);
    }

    if (WWC.enabled.woodenCard && !itemExistsInCart(cart, WWC.deals.card.handle)) {
      primary.push(WWC.deals.card);
    }

    return primary.concat(back).filter(function (deal) {
      var key = getGlobalOfferKey(deal);

      if (deal.handle && itemExistsInCart(cart, deal.handle) && !deal.repeatable) return false;
      if (!ignoreHidden && isOfferHidden(key)) return false;

      return true;
    }).slice(0, 5);
  }

  function getRestorableGlobalDeals(cart) {
    var hiddenGlobalKeys = getHiddenGlobalOfferKeys();

    if (!hiddenGlobalKeys.length) return [];

    return buildGlobalDeals(cart, true).filter(function (deal) {
      return hiddenGlobalKeys.indexOf(getGlobalOfferKey(deal)) !== -1;
    });
  }

  function priceHtml(item) {
    if (!item.price && !item.oldPrice) return '';

    return [
      '<span class="wwc-cart-upsell-price">',
      item.oldPrice ? '<s>' + escapeHtml(item.oldPrice) + '</s>' : '',
      item.price ? '<b>' + escapeHtml(item.price) + '</b>' : '',
      '</span>'
    ].join('');
  }

  function itemCardHtml(data, card) {
    var item = card.item;
    var key = getItemOfferKey(data, item);
    var attrs = '';

    if (card.type === 'upgrade') {
      attrs += ' data-wwc-upgrade';
      attrs += ' data-offer-key="' + escapeHtml(key) + '"';
      attrs += ' data-target-handle="' + escapeHtml(item.targetHandle) + '"';
      attrs += ' data-target-sku="' + escapeHtml(item.targetSku || '') + '"';
      attrs += ' data-upgrade-from="' + escapeHtml(item.from || '') + '"';
      attrs += ' data-upgrade-to="' + escapeHtml(item.to || '') + '"';
    } else {
      attrs += ' data-wwc-item-crosssell';
      attrs += ' data-offer-key="' + escapeHtml(key) + '"';
      attrs += ' data-handle="' + escapeHtml(item.handle) + '"';
      attrs += ' data-sku="' + escapeHtml(item.sku || '') + '"';
      attrs += ' data-attach="true"';
    }

    return [
      '<div class="wwc-cart-upsell__line wwc-cart-upsell__line--item" data-wwc-offer-card>',
      '<div class="wwc-cart-upsell__main">',
      '<strong>' + escapeHtml((item.emoji ? item.emoji + ' ' : '') + item.title) + '</strong>',
      '<span>' + escapeHtml(item.text) + '</span>',
      '</div>',
      '<button type="button" class="wwc-cart-upsell__cta" ' + attrs + '>...</button>',
      '</div>'
    ].join('');
  }

  function hydrateGlobalOfferImages() {
    document.querySelectorAll('[data-wwc-offer-image][data-handle]').forEach(function (holder) {
      var handle = holder.getAttribute('data-handle');
      if (!handle || holder.dataset.loaded === 'true') return;

      holder.dataset.loaded = 'true';

      loadProduct(handle).then(function (product) {
        var image = getProductImage(product);
        if (!image) return;

        holder.innerHTML = [
          '<img src="' + escapeHtml(image) + '"',
          ' alt="' + escapeHtml(product.title || '') + '"',
          ' loading="lazy" width="88" height="88">'
        ].join('');
      }).catch(function () {});
    });
  }

  function globalCardHtml(item, cart, index, total) {
  var key = getGlobalOfferKey(item);
  var cities = getCartCities(cart);
  var cityText = '';

  if (item.needsCity) {
    cityText = cities.length === 1 ? cities[0] + ' · ' : T.chooseCity;
  }

  var hasPreview = item.previewTitle || item.previewText;
  var attrs = '';
  var imageHtml = '';
  var actionLabel = T.add;

  if (item.custom === 'magnet') {
    attrs += ' data-wwc-magnet-action';
    attrs += ' data-offer-key="' + escapeHtml(key) + '"';

    imageHtml = [
      '<div class="wwc-cart-upsell-carousel__image wwc-cart-upsell-carousel__image--emoji">',
      escapeHtml(item.emoji || '✨'),
      '</div>'
    ].join('');
  } else {
    attrs += ' data-wwc-global-crosssell';
    attrs += ' data-offer-key="' + escapeHtml(key) + '"';
    attrs += ' data-handle="' + escapeHtml(item.handle) + '"';
    attrs += ' data-sku="' + escapeHtml(item.sku || '') + '"';
    attrs += item.variantId ? ' data-variant-id="' + escapeHtml(item.variantId) + '"' : '';   /* WWC ronde 28 */
    attrs += ' data-needs-city="' + (item.needsCity ? 'true' : 'false') + '"';
    attrs += ' data-needs-text="' + (item.needsText ? 'true' : 'false') + '"';
    attrs += ' data-selected-city="' + escapeHtml(cities.length === 1 ? cities[0] : '') + '"';

    imageHtml = [
      '<div class="wwc-cart-upsell-carousel__image" data-wwc-offer-image data-handle="' + escapeHtml(item.handle) + '">',
      '<span>' + escapeHtml(item.emoji || '✨') + '</span>',
      '</div>'
    ].join('');
  }

  return [
    '<div class="wwc-cart-upsell-carousel__card" data-wwc-offer-card>',
    imageHtml,

    '<div class="wwc-cart-upsell-carousel__content">',
    '<div class="wwc-cart-upsell-carousel__row">',
    item.badge ? '<span class="wwc-cart-upsell-badge">' + escapeHtml(item.badge) + '</span>' : '',
    total > 1 ? '<span class="wwc-cart-upsell-count">' + escapeHtml(T.tip) + ' ' + escapeHtml(index + 1) + ' ' + escapeHtml(T.of) + ' ' + escapeHtml(total) + '</span>' : '',
    '</div>',
    '<strong>' + escapeHtml(item.title) + '</strong>',
    '<span class="wwc-cart-upsell-subline">' + escapeHtml(cityText + item.text) + priceHtml(item) + '</span>',
    '</div>',

    '<div class="wwc-cart-upsell-carousel__actions">',
    '<button type="button" class="wwc-cart-upsell__plus" ' + attrs + ' aria-label="' + escapeHtml(actionLabel) + '">' + escapeHtml(actionLabel) + '</button>',
    item.needsCity ? '<button type="button" class="wwc-cart-upsell__citybtn" data-wwc-change-city>Wijzig plaats</button>' : '',
    hasPreview ? '<button type="button" class="wwc-cart-upsell__info" data-wwc-preview aria-label="Meer info">i</button>' : '',
    '</div>',

    hasPreview ? [
      '<div class="wwc-cart-upsell-preview" hidden data-wwc-preview-box>',
      '<strong>' + escapeHtml(item.previewTitle || '') + '</strong>',
      '<span>' + escapeHtml(item.previewText || '') + '</span>',
      '</div>'
    ].join('') : '',

    '<div class="wwc-cart-upsell-inline" hidden data-wwc-inline-choice></div>',
    '</div>'
  ].join('');
}

  function totalNavHtml(total) {
    if (total <= 1) return '';

    return [
      '<div class="wwc-cart-upsell-global__navwrap">',
      '<button type="button" class="wwc-cart-upsell-carousel__nav" data-wwc-global-prev aria-label="Vorige tip">‹</button>',
      '<button type="button" class="wwc-cart-upsell-carousel__nav" data-wwc-global-next aria-label="Volgende tip">›</button>',
      '</div>'
    ].join('');
  }

  /* =========================================================
     WWC dealsysteem ronde 28 (besluit Freek 11 okt): de tips gewoon tonen.
     Tot en met WWC_TIPS_MAX tips staan ze onder elkaar als compacte rijen:
     beeld, titel, tekst, prijs met doorhaling en de knop "Toevoegen".
     De carrousel (globalCardHtml, "Tip 1 van 3", pijltjes) alleen bij meer.
  ========================================================= */
  var WWC_TIPS_MAX = 4;

  function tipRijHtml(item, cart) {
    var key = getGlobalOfferKey(item);
    var cities = getCartCities(cart);
    var cityText = item.needsCity ? (cities.length === 1 ? cities[0] + ' · ' : T.chooseCity) : '';
    var hasPreview = item.previewTitle || item.previewText;
    var attrs = '';
    var beeld = '';

    if (item.custom === 'magnet') {
      attrs = ' data-wwc-magnet-action data-offer-key="' + escapeHtml(key) + '"';
      beeld = '<div class="wwc-tip__beeld wwc-tip__beeld--emoji">' + escapeHtml(item.emoji || '✨') + '</div>';
    } else {
      attrs = ' data-wwc-global-crosssell' +
        ' data-offer-key="' + escapeHtml(key) + '"' +
        ' data-handle="' + escapeHtml(item.handle) + '"' +
        ' data-sku="' + escapeHtml(item.sku || '') + '"' +
        (item.variantId ? ' data-variant-id="' + escapeHtml(item.variantId) + '"' : '') +
        ' data-needs-city="' + (item.needsCity ? 'true' : 'false') + '"' +
        ' data-needs-text="' + (item.needsText ? 'true' : 'false') + '"' +
        ' data-selected-city="' + escapeHtml(cities.length === 1 ? cities[0] : '') + '"';
      beeld = '<div class="wwc-tip__beeld" data-wwc-offer-image data-handle="' + escapeHtml(item.handle) + '"><span>' + escapeHtml(item.emoji || '✨') + '</span></div>';
    }

    return [
      '<div class="wwc-tip" data-wwc-offer-card data-wwc-tip="' + escapeHtml(item.id || item.custom || item.handle) + '">',
      beeld,
      '<div class="wwc-tip__tekst">',
      '<span class="wwc-tip__kop"><span class="wwc-tip__naam">' + escapeHtml(item.title) + '</span>',
      hasPreview ? '<button type="button" class="wwc-tip__info" data-wwc-preview aria-label="' + escapeHtml(T.moreInfo) + '">i</button>' : '',
      '</span>',
      (cityText || item.text) ? '<span class="wwc-cart-upsell-subline">' + escapeHtml(cityText + (item.text || '')) + '</span>' : '',
      '</div>',
      '<div class="wwc-tip__prijsregel">',
      '<span class="wwc-tip__prijs" data-wwc-tip-prijs>' + priceHtml(item) + '</span>',
      item.needsCity ? '<button type="button" class="wwc-tip__plaats" data-wwc-change-city>' + escapeHtml(T.changeCity) + '</button>' : '',
      '</div>',
      '<button type="button" class="wwc-tip__knop"' + attrs + '>' + escapeHtml(T.add) + '</button>',
      hasPreview ? [
        '<div class="wwc-cart-upsell-preview" hidden data-wwc-preview-box>',
        '<strong>' + escapeHtml(item.previewTitle || '') + '</strong>',
        '<span>' + escapeHtml(item.previewText || '') + '</span>',
        '</div>'
      ].join('') : '',
      '<div class="wwc-cart-upsell-inline" hidden data-wwc-inline-choice></div>',
      '</div>'
    ].join('');
  }

  function tipsHtml(deals, cart, hiddenCount) {
    return [
      '<div class="wwc-cart-upsell-global__inner wwc-tips-wrap">',
      '<div class="wwc-cart-upsell-global__top"><div class="wwc-cart-upsell-global__head">' + escapeHtml(T.oftenTogether) + '</div></div>',
      '<div class="wwc-tips">',
      deals.map(function (deal) { return tipRijHtml(deal, cart); }).join(''),
      '</div>',
      hiddenCount ? '<button type="button" class="wwc-cart-upsell-restore" data-wwc-restore-offers>' + escapeHtml(T.moreTips) + '</button>' : '',
      '</div>'
    ].join('');
  }

  /* Een tip met een variant-id (de batterijen) toont de prijs die Shopify voor die variant heeft, zodat de mand na "Toevoegen" hetzelfde
     bedrag laat zien. Bestaat de variant niet (meer) of is hij uitverkocht, dan verdwijnt de rij. Alleen in euro (de vaste teksten zijn in euro). */
  function hydrateTipPrices() {
    var d = drawer();
    if (!d) return;
    var munt = window.Shopify && Shopify.currency && Shopify.currency.active;
    var euro = !munt || munt === 'EUR';   /* ronde 29: niet meer nodig voor de prijs (formatMoney volgt de valuta); blijft voor wie hem leest */

    d.querySelectorAll('.wwc-tip [data-wwc-global-crosssell][data-variant-id]').forEach(function (button) {
      var handle = button.getAttribute('data-handle');
      var id = Number(button.getAttribute('data-variant-id'));
      if (!handle || !id || button.dataset.wwcPrijsKlaar === 'true') return;
      button.dataset.wwcPrijsKlaar = 'true';

      loadProduct(handle).then(function (product) {
        var card = button.closest('[data-wwc-offer-card]');
        if (!card) return;
        var variant = (product.variants || []).find(function (v) { return Number(v.id) === id; });

        if (!variant || variant.available === false) {
          card.hidden = true;
          var lijst = card.closest('.wwc-tips-wrap');
          if (lijst && !lijst.querySelector('.wwc-tip:not([hidden])')) lijst.hidden = true;
          return;
        }

        var prijs = Number(variant.price || 0);
        var oud = Number(variant.compare_at_price || 0);
        var plek = card.querySelector('[data-wwc-tip-prijs]');
        if (plek && prijs > 0) {   /* ronde 29: ook buiten de euro, want formatMoney volgt nu de valuta (was: alleen als euro) */
          plek.innerHTML = priceHtml({ oldPrice: oud > prijs ? formatMoney(oud) : '', price: formatMoney(prijs) });
        }
      }).catch(function () {});
    });
  }

  function ensureTipsCss() {
    if (document.getElementById('wwc-tips-css')) return;
    var p = '#CartDrawer [data-wwc-global-upsell] ';
    var s = document.createElement('style');
    s.id = 'wwc-tips-css';
    s.textContent = [
      p + '.wwc-tips-wrap[hidden],' + p + '.wwc-tips .wwc-tip[hidden]{display:none}',
      p + '.wwc-tips-wrap .wwc-cart-upsell-global__top{display:flex;align-items:center;margin:0 0 8px}',
      p + '.wwc-tips-wrap .wwc-cart-upsell-global__head{margin:0;color:#171717;font-size:15px;font-weight:850;line-height:1.2}',
      p + '.wwc-tips{display:grid;gap:8px}',
      p + '.wwc-tips .wwc-tip{position:relative;display:grid;grid-template-columns:48px minmax(0,1fr) auto;grid-template-areas:"beeld tekst tekst" "beeld prijs knop";column-gap:10px;row-gap:3px;align-items:center;padding:7px 10px;border:1px solid rgba(17,17,17,.09);border-radius:14px;background:#fff}',
      p + '.wwc-tips .wwc-tip__beeld{grid-area:beeld;align-self:center;width:48px;height:48px;border:1px solid rgba(181,129,80,.14);border-radius:10px;background:#fff;overflow:hidden;display:flex;align-items:center;justify-content:center;font-size:22px;line-height:1}',
      p + '.wwc-tips .wwc-tip__beeld img{width:100%;height:100%;object-fit:contain;display:block;padding:3px}',
      p + '.wwc-tips .wwc-tip__tekst{grid-area:tekst;min-width:0}',
      p + '.wwc-tips .wwc-tip__kop{display:flex;align-items:center;gap:6px;min-width:0}',
      p + '.wwc-tips .wwc-tip__naam{display:block;min-width:0;color:#171717;font-size:13.5px;font-weight:850;line-height:1.2}',
      p + '.wwc-tips .wwc-cart-upsell-subline{display:block;margin-top:2px;color:rgba(17,17,17,.64);font-size:12px;line-height:1.3}',
      p + '.wwc-tips .wwc-tip__prijsregel{grid-area:prijs;min-width:0;display:flex;flex-wrap:wrap;align-items:center;gap:2px 10px}',
      p + '.wwc-tips .wwc-cart-upsell-price{display:inline-flex;align-items:baseline;gap:5px;margin:0;white-space:nowrap;font-size:13.5px;line-height:1.2}',
      p + '.wwc-tips .wwc-cart-upsell-price s{color:rgba(17,17,17,.45);font-size:.92em;font-weight:650}',
      p + '.wwc-tips .wwc-cart-upsell-price b{color:#5f3b1e;font-size:1em;font-weight:900}',
      p + '.wwc-tips .wwc-tip__plaats{border:0;background:none;padding:2px 0;color:#7a502b;font-size:12px;font-weight:800;line-height:1.2;text-decoration:underline;text-underline-offset:2px;cursor:pointer}',
      p + '.wwc-tips .wwc-tip__info{flex:0 0 auto;width:20px;height:20px;padding:0;border:1px solid rgba(181,129,80,.32);border-radius:999px;background:#fff;color:#7a502b;font:900 11px/1 Georgia,serif;display:inline-flex;align-items:center;justify-content:center;cursor:pointer}',
      p + '.wwc-tips .wwc-tip__knop{grid-area:knop;justify-self:end;min-height:34px;padding:0 14px;border:0;border-radius:999px;background:#b58150;color:#fff;font-size:13px;font-weight:850;line-height:1;white-space:nowrap;cursor:pointer;box-shadow:0 4px 10px rgba(181,129,80,.18)}',
      p + '.wwc-tips .wwc-tip__knop:hover{background:#986536}',
      p + '.wwc-tips .wwc-tip__knop[disabled]{opacity:.6;cursor:wait}',
      p + '.wwc-tips .wwc-tip>.wwc-cart-upsell-preview,' + p + '.wwc-tips .wwc-tip>.wwc-cart-upsell-inline,' + p + '.wwc-tips .wwc-tip>.wwc-cart-upsell__error{grid-column:1 / -1;margin-top:3px}',
      p + '.wwc-tips .wwc-tip>.wwc-cart-upsell-preview[hidden],' + p + '.wwc-tips .wwc-tip>.wwc-cart-upsell-inline[hidden]{display:none}'
    ].join('\n');
    document.head.appendChild(s);
  }

  function ensureGlobalContainer() {
    var d = drawer();
    if (!d) return null;

    var existing = d.querySelector('[data-wwc-global-upsell]');
    if (existing) {
      existing.classList.add('wwc-cart-upsell-global');
      return existing;
    }

    var products = d.querySelector('[data-products]');
    if (!products) return null;

    var box = document.createElement('div');
    box.className = 'wwc-cart-upsell-global';
    box.setAttribute('data-wwc-global-upsell', '');

    products.insertAdjacentElement('afterend', box);
    return box;
  }

  function renderItemNudges(cart) {
    document.querySelectorAll('[data-wwc-cart-upsell]').forEach(function (el) {
      var data = getData(el);

      if (!data.key || !data.handle || isAddonProductData(data)) {
        if (el.innerHTML) el.innerHTML = '';
        return;
      }

      var card = buildItemNudge(data, cart);
      var sig = data.key + '|' + data.sku + '|' + getHiddenOffers().join(',');

      if (el.dataset.wwcSig === sig && el.innerHTML.trim()) return;

      el.dataset.wwcSig = sig;
      el.innerHTML = card ? itemCardHtml(data, card) : '';
    });
  }

  function renderGlobalNudges(cart) {
    var box = ensureGlobalContainer();
    if (!box) return;

    var deals = buildGlobalDeals(cart, false);
  var restorableDeals = getRestorableGlobalDeals(cart);
  var hiddenCount = restorableDeals.length;

    if (!deals.length) {
      box.innerHTML = hiddenCount ? [
        '<div class="wwc-cart-upsell-global__inner">',
        '<button type="button" class="wwc-cart-upsell-restore" data-wwc-restore-offers>Meer tips bekijken</button>',
        '</div>'
      ].join('') : '';
      return;
    }

    var index = clampGlobalIndex(getGlobalIndex(), deals.length);
    setGlobalIndex(index);

    var sig = [
      cart.item_count,
      getHiddenOffers().join(','),
      getCartCities(cart).join(','),
      index,
      deals.map(function (deal) {
        return (deal.id || deal.custom || deal.handle) + (deal.variantId ? '@' + deal.variantId : '');
      }).join(',')
    ].join('|');

    if (box.dataset.wwcSig === sig && box.innerHTML.trim()) {
      hydrateGlobalOfferImages();
      return;
    }

    box.dataset.wwcSig = sig;

    /* WWC dealsysteem ronde 28 (besluit Freek 11 okt): tot en met WWC_TIPS_MAX tips gewoon onder elkaar; de carrousel hieronder alleen bij meer */
    if (deals.length <= WWC_TIPS_MAX) {
      ensureTipsCss();
      box.innerHTML = tipsHtml(deals, cart, hiddenCount);
      hydrateGlobalOfferImages();
      hydrateTipPrices();
      return;
    }

    box.innerHTML = [
      '<div class="wwc-cart-upsell-global__inner wwc-cart-upsell-global__inner--carousel">',
      '<div class="wwc-cart-upsell-global__top">',
      '<div class="wwc-cart-upsell-global__head">' + escapeHtml(T.oftenTogether) + '</div>',
      totalNavHtml(deals.length),
      '</div>',
      '<div class="wwc-cart-upsell-carousel">',
      globalCardHtml(deals[index], cart, index, deals.length),
      '</div>',
      hiddenCount ? '<button type="button" class="wwc-cart-upsell-restore" data-wwc-restore-offers>Meer tips bekijken</button>' : '',
      '</div>'
    ].join('');

    hydrateGlobalOfferImages();
  }

  function updateUpgradePrices(cart) {
    document.querySelectorAll('[data-wwc-upgrade]').forEach(function (button) {
      if (button.dataset.priceReady === 'true') return;

      var wrap = button.closest('[data-wwc-cart-upsell]');
      if (!wrap) return;

      var data = getData(wrap);

      Promise.all([
        loadProduct(data.handle),
        getVariant(button.getAttribute('data-target-handle'), button.getAttribute('data-target-sku'))
      ]).then(function (result) {
        var sourceProduct = result[0];
        var targetVariant = result[1];

        var sourceVariant = (sourceProduct.variants || []).find(function (variant) {
          return String(variant.sku || '').toLowerCase() === String(data.sku || '').toLowerCase();
        });

        /*
          Belangrijk:
          - sourceVariant.price = basisprijs huidige maat
          - targetVariant.price = basisprijs upgrade maat
          - line.price gebruiken we bewust niet, want Infinite Options kan daar extra kosten in zetten.
        */

        var sourcePrice = sourceVariant ? Number(sourceVariant.price || 0) : 0;
        var targetPrice = Number(targetVariant.price || 0);

        var diff = sourcePrice > 0 ? targetPrice - sourcePrice : 0;

        if (diff <= 0) {
          button.textContent = 'Upgrade';
          button.setAttribute('aria-label', 'Upgrade');
        } else {
          var label = '+' + formatMoney(diff);

          button.textContent = label;
          button.setAttribute('aria-label', T.upgradeFor + ' ' + label);
        }

        button.dataset.priceReady = 'true';
      }).catch(function () {
        button.textContent = 'Upgrade';
        button.setAttribute('aria-label', 'Upgrade');
      });
    });
  }

  function prefetchUpgradeVariants() {
    document.querySelectorAll('[data-wwc-upgrade]').forEach(function (button) {
      getVariant(button.getAttribute('data-target-handle'), button.getAttribute('data-target-sku')).catch(function () {});
    });
  }

  function getCartLineNode(upsellNode) {
    if (!upsellNode) return null;

    return (
        upsellNode.closest('.ajaxcart__product') ||
        upsellNode.closest('.ajaxcart__row') ||
        upsellNode.closest('.cart__item') ||
        upsellNode.closest('.cart-item') ||
        upsellNode.closest('[data-cart-item]') ||
        upsellNode.closest('[data-line-item]') ||
        upsellNode.closest('[data-cart-drawer-item]') ||
        upsellNode.closest('.drawer__cart-item') ||
        upsellNode.closest('[data-key]') ||
        upsellNode.parentElement
    );
}



    function addRemoveButtonToLine(lineNode, key) {
      if (!lineNode || !key) return;
      if (lineNode.querySelector('[data-wwc-remove-line]')) return;

      lineNode.classList.add('wwc-cart-line-has-remove');

      var target =
        lineNode.querySelector('.ajaxcart__product-name') ||
        lineNode.querySelector('.ajaxcart__product-title') ||
        lineNode.querySelector('.cart__item-name') ||
        lineNode.querySelector('.cart-item__name') ||
        lineNode.querySelector('[data-cart-item-title]') ||
        lineNode.querySelector('.cart__item-details') ||
        lineNode.querySelector('.ajaxcart__product-meta') ||
        lineNode;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'wwc-cart-line-remove';
      button.setAttribute('data-wwc-remove-line', '');
      button.setAttribute('data-line-key', key);
      button.setAttribute('aria-label', T.removeProduct);

      button.innerHTML = [
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
        '<path d="M9 3h6l1 2h4v2H4V5h4l1-2Z"></path>',
        '<path d="M6 9h12l-1 11H7L6 9Zm4 2v7h2v-7h-2Zm4 0v7h2v-7h-2Z"></path>',
        '</svg>'
      ].join('');

      target.appendChild(button);
    }

    function getAddonSortRank(data) {
      var handle = String(data.handle || '').toLowerCase();
      var title = String(data.title || '').toLowerCase();
      var type = String(data.type || '').toLowerCase();
      var sku = String(data.sku || '').toLowerCase();
      var haystack = handle + ' ' + title + ' ' + type + ' ' + sku;

      if (handle === 'met-verlichting' || haystack.indexOf('verlichting') !== -1) return 10;
      if (haystack.indexOf('duracell') !== -1 || haystack.indexOf('batterijen') !== -1) return 20;
      if (haystack.indexOf('houten-kaartje') !== -1 || haystack.indexOf('kaartje') !== -1) return 30;
      if (haystack.indexOf('broodplankje') !== -1 || haystack.indexOf('broodplank') !== -1) return 40;
      if (haystack.indexOf('onderzetters') !== -1 || haystack.indexOf('coaster') !== -1) return 50;
      if (handle.indexOf('cartdeal-') === 0) return 90;

      return 100;
    }


      function sortAddonItemsToBottom() {
        if (!WWC.enabled.sortAddonsToBottom || suppressObserver) return;

        var d = drawer();
        if (!d) return;

        var products = d.querySelector('[data-products]');
        if (!products) return;

        var nodes = Array.prototype.slice.call(products.children);

        if (!nodes.length) return;

        var rows = nodes.map(function (node, index) {
          if (!node || node.nodeType !== 1) {
            return null;
          }

          if (!node.dataset.wwcOriginalIndex) {
            node.dataset.wwcOriginalIndex = String(index);
          }

          var upsell = node.querySelector('[data-wwc-cart-upsell]');
          var data = upsell ? getData(upsell) : {
            handle: node.getAttribute('data-product-handle') || '',
            title: node.textContent || '',
            type: node.getAttribute('data-product-type') || '',
            sku: node.getAttribute('data-variant-sku') || ''
          };

          var isAddon = isAddonProductData(data);
          var addonRank = isAddon ? getAddonSortRank(data) : 0;

          node.classList.toggle('wwc-cart-line--addon', isAddon);

          return {
            node: node,
            isAddon: isAddon,
            groupRank: isAddon ? 1 : 0,
            addonRank: addonRank,
            originalIndex: Number(node.dataset.wwcOriginalIndex || index)
          };
        }).filter(Boolean);

        var sorted = rows.slice().sort(function (a, b) {
          if (a.groupRank !== b.groupRank) return a.groupRank - b.groupRank;
          if (a.addonRank !== b.addonRank) return a.addonRank - b.addonRank;
          return a.originalIndex - b.originalIndex;
        });

        var changed = sorted.some(function (row, index) {
          return row.node !== nodes[index];
        });

        if (!changed) return;

        suppressObserver = true;

        sorted.forEach(function (row) {
          products.appendChild(row.node);
        });

        setTimeout(function () {
          suppressObserver = false;
        }, 120);
      }

      function updateAfterProductsNudge() {
        var d = drawer();
        if (!d) return;

        var nudge = d.querySelector('[data-wwc-after-products-nudge]');
        var scrollArea = d.querySelector('.drawer__scrollable');

        if (!nudge || !scrollArea) return;

        var globalUpsell = d.querySelector('[data-wwc-global-upsell]');
        var note = d.querySelector('[data-cart-note]');
        var discount = d.querySelector('[data-cart-discount]');
        var continueShopping = d.querySelector('.cart__continue, [data-cart-continue], .wwc-cart-continue');

        var hasGlobalUpsell = !!(
          globalUpsell &&
          globalUpsell.textContent &&
          globalUpsell.textContent.trim().length > 0
        );

        var target =
          hasGlobalUpsell ? globalUpsell :
          note ? note :
          discount ? discount :
          continueShopping ? continueShopping :
          null;

        if (!target) {
          nudge.hidden = true;
          nudge.classList.remove('is-visible');
          return;
        }

        var canScroll = scrollArea.scrollHeight > scrollArea.clientHeight + 32;
        var nearBottom = scrollArea.scrollTop + scrollArea.clientHeight >= scrollArea.scrollHeight - 80;

        var scrollRect = scrollArea.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();

        var targetIsNotFullyVisible = targetRect.bottom > scrollRect.bottom - 40;
        var shouldShow = canScroll && !nearBottom && targetIsNotFullyVisible;

        nudge.hidden = !shouldShow;
        nudge.classList.toggle('is-visible', shouldShow);
      }

 

  function updateScrollHint() {
    var d = drawer();
    if (!d) return;

    var products = d.querySelector('[data-products]');

    if (products) {
      var canScroll = products.scrollHeight > products.clientHeight + 12;
      var nearBottom = products.scrollTop + products.clientHeight >= products.scrollHeight - 24;

      products.classList.toggle('wwc-cart-scrollable', canScroll && !nearBottom);
    }

    updateAfterProductsNudge();
  }

  function updateMobileScrollHint() {
    var d = drawer();
    if (!d) return;

    d.querySelectorAll('[data-wwc-mobile-scroll-hint], [data-wwc-mobile-scroll-hint-footer]').forEach(function (el) {
      el.remove();
    });

    var scrollArea = d.querySelector('.drawer__scrollable');
    if (scrollArea) {
      scrollArea.classList.remove('has-more-content', 'is-at-bottom');
    }

    updateAfterProductsNudge();
  }

  function getCartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';

    return cart.items.map(function (item) {
      return [
        item.key || '',
        item.quantity || 0,
        item.final_line_price || item.line_price || 0
      ].join(':');
    }).join('|') + '::' + String(cart.total_price || 0);
  }

  function updateHomeDeliveryNote(cart) {
    var d = drawer();
    if (!d) return;

    var note = d.querySelector('[data-wwc-home-delivery-note]');
    if (!note) return;

    var items = Array.isArray(cart.items) ? cart.items : [];

    var shouldShow = items.some(function (item) {
      var productType = String(item.product_type || '').toLowerCase();
      var title = String(item.product_title || item.title || '').toLowerCase();
      var handle = String(item.handle || item.url || '').toLowerCase();
      var itemText = productType + ' ' + title + ' ' + handle;

      var itemIsClock = itemText.indexOf('klok') !== -1 || itemText.indexOf('clock') !== -1;
      var itemIsSkyline = productType.indexOf('skyline') !== -1;
      var itemIsStanding = itemText.indexOf('standing') !== -1 || itemText.indexOf('staande') !== -1;

      var itemIsSmallSkyline =
        itemText.indexOf('onderzetter') !== -1 ||
        itemText.indexOf('coaster') !== -1 ||
        itemText.indexOf('magneet') !== -1 ||
        itemText.indexOf('magnet') !== -1 ||
        itemText.indexOf('telefoonhouder') !== -1 ||
        itemText.indexOf('phone holder') !== -1 ||
        itemText.indexOf('desk organizer') !== -1 ||
        itemText.indexOf('desk organiser') !== -1 ||
        itemText.indexOf('serveerplank') !== -1 ||
        itemText.indexOf('broodplank') !== -1 ||
        itemText.indexOf('mini') !== -1;

      var itemIsLargeSkyline = itemIsSkyline && !itemIsStanding && !itemIsSmallSkyline;

      return itemIsClock || itemIsLargeSkyline;
    });

    note.classList.toggle('is-visible', shouldShow);
    note.hidden = !shouldShow;
  }

  function updateFreeShipping(cart) {
    var d = drawer();
    if (!d || !cart) return;

    var freeshipEl = d.querySelector('.wwc-freeship');
    var thresholdAttr = freeshipEl ? freeshipEl.getAttribute('data-threshold') : null;
    var threshold = Number(thresholdAttr || WWC.freeShippingThreshold);

    var subtotal = Number(cart.total_price || 0);
    var left = Math.max(0, threshold - subtotal);
    var pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100 || 0));

    var bar = d.querySelector('.wwc-freeship__bar span');
    var text = d.querySelector('.wwc-freeship__text');

    if (bar) bar.style.width = pct + '%';

    if (text) {
      if (left > 0) {
        text.classList.remove('is-reached');
        text.setAttribute('data-free-text', 'false');
        text.innerHTML = '🚚 ' + escapeHtml(T.freeLeftBefore) + ' <strong>€<span data-left>' + eurosOnly(left) + '</span></strong> ' + escapeHtml(T.freeLeftAfter);
      } else {
        text.classList.add('is-reached');
        text.setAttribute('data-free-text', 'true');
        text.textContent = T.freeReached;
      }
    }
  }

  function updateCartDealOnlyGuard(cart) {
    var d = drawer();
    if (!d || !cart || !Array.isArray(cart.items)) return;

    var form = d.querySelector('#CartDrawerForm');
    var checkoutBtn = d.querySelector('.cart__checkout');
    if (!form || !checkoutBtn) return;

    var items = cart.items || [];

    var hasItems = items.length > 0;

    var cartDealOnly = hasItems && items.every(function (item) {
      return String(item.handle || '').toLowerCase().indexOf('cartdeal-') !== -1;
    });

    var existing = d.querySelector('[data-wwc-cartdeal-only-warning]');

    if (cartDealOnly) {
      form.setAttribute('data-wwc-cartdeal-only', 'true');

      checkoutBtn.disabled = true;
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.classList.add('wwc-cart-checkout-disabled');

      if (!existing) {
        var warning = document.createElement('div');
        warning.className = 'wwc-cartdeal-only-warning';
        warning.setAttribute('data-wwc-cartdeal-only-warning', '');
        warning.innerHTML = [
          '<strong>🦫 Knaag-alert: dit is een extraatje</strong>',
          '<span>' + escapeHtml(T.cartdealText) + '</span>',
          '<a href="/pages/alle-steden">Zoek je skyline</a>'
        ].join('');

        var footer = d.querySelector('.cart__checkout-wrapper');
        if (footer) {
          footer.insertAdjacentElement('beforebegin', warning);
        }
      }

      return;
    }

    form.removeAttribute('data-wwc-cartdeal-only');

    checkoutBtn.disabled = false;
    checkoutBtn.removeAttribute('aria-disabled');
    checkoutBtn.classList.remove('wwc-cart-checkout-disabled');

    if (existing) existing.remove();
  }

  function updateCartDrawerStaticParts(cart) {
    var d = drawer();
    if (!d || !cart) return;

    var subtotalNode = d.querySelector('[data-subtotal]');
    if (subtotalNode) subtotalNode.textContent = formatMoney(cart.total_price || 0);

    updateFreeShipping(cart);
    updateHomeDeliveryNote(cart);
    updateCartDealOnlyGuard(cart);
    updateFooterDiscounts(cart);
    updateScrollHint();

    setTimeout(updateMobileScrollHint, 80);
  }

  function scheduleStaticRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    if (lateRefreshTimer) clearTimeout(lateRefreshTimer);

    refreshTimer = setTimeout(refreshStaticCartParts, 280);
    lateRefreshTimer = setTimeout(refreshStaticCartParts, 850);
  }

  function refreshStaticCartParts() {
    if (refreshController) refreshController.abort();
    refreshController = new AbortController();

    getJson(endpoint('/cart.js') + '?_wwc=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      signal: refreshController.signal
    }).then(function (cart) {
      var signature = getCartSignature(cart);
      var changed = signature !== lastCartSignature;

      lastCartSignature = signature;
      cartCache = cart;

      updateCartDrawerStaticParts(cart);

      if (changed) scheduleRender(20);
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      console.error('[WWC static refresh error]', e);
    });
  }

  function render() {
    getCart(false).then(function (cart) {
      renderItemNudges(cart);
      renderGlobalNudges(cart);
      updateUpgradePrices(cart);
      prefetchUpgradeVariants();
      sortAddonItemsToBottom();
      updateCartDrawerStaticParts(cart);
      updateScrollHint();

      setTimeout(updateMobileScrollHint, 80);
    }).catch(function (err) {
      console.error('[WWC render error]', err);
    });
  }

  function scheduleRender(delay) {
    if (renderTimer) clearTimeout(renderTimer);

    renderTimer = setTimeout(function () {
      render();
    }, typeof delay === 'number' ? delay : 80);
  }

  function setBusy(button, state, text) {
    if (!button) return;

    button.disabled = !!state;

    if (state) {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent;
      }

      button.textContent = text || T.busy;
    } else {
      button.textContent = button.dataset.originalText || '+';
      delete button.dataset.originalText;
    }
  }

  function getLineFromCart(key) {
    return getCart(true).then(function (cart) {
      var line = (cart.items || []).find(function (item) {
        return item.key === key;
      });

      if (!line) throw new Error('Cart line niet gevonden');
      return line;
    });
  }

  function setCartAttributesSafe(attrs) {
    return postJson(endpoint('/cart/update.js'), { attributes: attrs }).catch(function () {});
  }

  function dispatchCartEvents(cart) {
    window.WWCLastCart = cart;

    ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:afterUpdate'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, {
        detail: { cart: cart, source: 'wwc-cart-drawer' }
      }));
    });
  }

  function requestThemeCartRefresh(cart) {
    dispatchCartEvents(cart);

    if (window.theme && theme.cart) {
      try {
        if (typeof theme.cart.getCart === 'function') theme.cart.getCart();
        if (typeof theme.cart.updateCart === 'function') theme.cart.updateCart();
        if (typeof theme.cart.refresh === 'function') theme.cart.refresh();
      } catch (e) {}
    }

    if (window.ajaxCart) {
      try {
        if (typeof window.ajaxCart.load === 'function') window.ajaxCart.load();
        if (typeof window.ajaxCart.update === 'function') window.ajaxCart.update();
      } catch (e) {}
    }
  }

  function refreshCartMarkupFast() {
    clearCartCache();

    return getCart(true).then(function (cart) {
      requestThemeCartRefresh(cart);
      updateCartDrawerStaticParts(cart);

      setTimeout(function () {
        clearCartCache();
        sortAddonItemsToBottom();
        scheduleRender(20);
      }, 120);

      setTimeout(function () {
        clearCartCache();
        sortAddonItemsToBottom();
        scheduleRender(20);
      }, 500);

      return cart;
    });
  }

  function upgradeLine(button) {
    if (busy) return;

    var wrap = button.closest('[data-wwc-cart-upsell]');
    if (!wrap) return;

    var data = getData(wrap);
    var offerKey = button.getAttribute('data-offer-key');
    var started = Date.now();

    busy = true;
    setBusy(button, true, T.busy);
    wrap.classList.add('is-upgrading');

    Promise.all([
      getLineFromCart(data.key),
      getVariant(button.getAttribute('data-target-handle'), button.getAttribute('data-target-sku'))
    ]).then(function (result) {
      var oldLine = result[0];
      var variant = result[1];
      var props = Object.assign({}, oldLine.properties || {});

      props._wwc_upgrade = 'true';
      props._wwc_upgrade_from = button.getAttribute('data-upgrade-from');
      props._wwc_upgrade_to = button.getAttribute('data-upgrade-to');

      hideOffer(offerKey);

      return postJson(endpoint('/cart/add.js'), {
        items: [{
          id: variant.id,
          quantity: oldLine.quantity || 1,
          properties: props
        }]
      }).then(function () {
        return postJson(endpoint('/cart/change.js'), {
          id: oldLine.key,
          quantity: 0
        });
      }).then(function () {
        return setCartAttributesSafe({ wwc_upsell_used: 'true' });
      });
    }).then(function () {
      console.log('[WWC upgrade]', Date.now() - started + 'ms');
      return refreshCartMarkupFast();
    }).catch(function (err) {
      console.error('[WWC upgrade error]', err);
      showCardError(button, T.upgradeError);
    }).finally(function () {
      busy = false;

      if (button && document.body.contains(button)) setBusy(button, false);
      if (wrap && document.body.contains(wrap)) wrap.classList.remove('is-upgrading');

      setTimeout(function () {
        busy = false;
      }, 300);
    });
  }

  function addCrossSell(button, payload) {
    if (busy) return;

    busy = true;
    setBusy(button, true, '…');

    /* WWC dealsysteem ronde 28: met een variant-id meteen dat id (batterijen), anders zoals altijd handle + sku */
    (payload.variantId ? Promise.resolve({ id: payload.variantId }) : getVariant(payload.handle, payload.sku)).then(function (variant) {
      return postJson(endpoint('/cart/add.js'), {
        items: [{
          id: variant.id,
          quantity: 1,
          properties: payload.properties || {}
        }]
      });
    }).then(function () {
      if (!payload.repeatable) hideOffer(payload.offerKey);

      return setCartAttributesSafe({ wwc_crosssell_used: 'true' }).then(function () {
        return refreshCartMarkupFast();
      });
    }).catch(function (err) {
      console.error('[WWC crosssell error]', err);
      showCardError(button, T.addError);
    }).finally(function () {
      busy = false;

      if (button && document.body.contains(button)) setBusy(button, false);

      setTimeout(function () {
        busy = false;
      }, 300);
    });
  }

  function removeCartLine(button) {
    if (!button || busy) return;

    var key = button.getAttribute('data-line-key');
    if (!key) return;

    busy = true;
    button.disabled = true;
    button.classList.add('is-loading');

    postJson(endpoint('/cart/change.js'), {
      id: key,
      quantity: 0
    }).then(function () {
      clearCartCache();
      return refreshCartMarkupFast();
    }).catch(function (err) {
      console.error('[WWC remove line error]', err);
      button.disabled = false;
      button.classList.remove('is-loading');
    }).finally(function () {
      busy = false;
    });
  }

  function showCardError(button, message) {
    var card = button.closest('[data-wwc-offer-card]');
    if (!card) return;

    var error = card.querySelector('[data-wwc-error]');
    if (!error) {
      error = document.createElement('p');
      error.className = 'wwc-cart-upsell__error';
      error.setAttribute('data-wwc-error', '');
      card.appendChild(error);
    }

    error.textContent = message;
  }

  function isRepeatableButton(button) {
    var handle = button.getAttribute('data-handle') || '';
    return handle === WWC.deals.breadboard.handle || handle === WWC.deals.coasters.handle;
  }

  function openGlobalCrossSell(button) {
    var card = button.closest('[data-wwc-offer-card]');
    var needsCity = button.getAttribute('data-needs-city') === 'true';
    var needsText = button.getAttribute('data-needs-text') === 'true';
    var selectedCity = button.getAttribute('data-selected-city') || '';

    if (needsCity && !selectedCity) {
      openCityPicker(card, button, true);
      return;
    }

    if (needsText) {
      openTextPicker(card, button);
      return;
    }

    var props = {};
    if (needsCity) props.Plaatskeuze = selectedCity;

    addCrossSell(button, {
      handle: button.getAttribute('data-handle'),
      sku: button.getAttribute('data-sku'),
      offerKey: button.getAttribute('data-offer-key'),
      variantId: Number(button.getAttribute('data-variant-id')) || 0,   /* WWC dealsysteem ronde 28: toevoegen op variant-id */
      repeatable: isRepeatableButton(button),
      properties: props
    });
  }

  function openItemCrossSell(button) {
    var wrap = button.closest('[data-wwc-cart-upsell]');
    if (!wrap) return;

    var data = getData(wrap);

    addCrossSell(button, {
      handle: button.getAttribute('data-handle'),
      sku: button.getAttribute('data-sku'),
      offerKey: button.getAttribute('data-offer-key'),
      properties: {
        // idem: de naam van deze eigenschap hoort de taal van de klant te volgen
        [T.belongsTo]: data.title
      }
    });
  }

  function getInlineBox(card) {
    var box = card.querySelector('[data-wwc-inline-choice]');

    if (!box) {
      box = document.createElement('div');
      box.className = 'wwc-cart-upsell-inline';
      box.hidden = true;
      box.setAttribute('data-wwc-inline-choice', '');
      card.appendChild(box);
    }

    return box;
  }

  function closeInlineBox(box) {
    box.hidden = true;
    box.innerHTML = '';
    box.removeAttribute('data-mode');
  }

  function openTextPicker(card, button) {
    var box = getInlineBox(card);

    if (!box.hidden && box.getAttribute('data-mode') === 'text') {
      closeInlineBox(box);
      return;
    }

    box.hidden = false;
    box.setAttribute('data-mode', 'text');

    box.innerHTML = [
      '<p class="wwc-cart-upsell-inline__hint">' + escapeHtml(T.cardTextHint) + '</p>',
      '<textarea class="wwc-cart-upsell-inline__textarea" data-inline-text maxlength="160" placeholder="Bijv. Veel liefs van ons"></textarea>',
      '<button type="button" class="wwc-cart-upsell-inline__submit" data-inline-submit>Kaartje toevoegen</button>',
      '<p class="wwc-cart-upsell-inline__error" data-inline-error></p>'
    ].join('');
  }

  function openCityPicker(card, button, forceOpen) {
    var box = getInlineBox(card);

    if (!forceOpen && !box.hidden && box.getAttribute('data-mode') === 'city') {
      closeInlineBox(box);
      return;
    }

    loadCities().then(function () {
      getCart(false).then(function (cart) {
        var cartCities = getCartCities(cart);
        var showChips = cartCities.length > 1;
        var chips = '';

        box.hidden = false;
        box.setAttribute('data-mode', 'city');

        if (showChips) {
          cartCities.slice(0, 6).forEach(function (city) {
            chips += '<button type="button" class="wwc-cart-upsell-chip" data-city-choice data-city-name="' + escapeHtml(city) + '">' + escapeHtml(city) + '</button>';
          });
        }

        box.innerHTML = [
          '<p class="wwc-cart-upsell-inline__hint">',
          showChips ? T.cityHintMany : T.cityHintOne,
          '</p>',
          showChips ? '<div class="wwc-cart-upsell-chips">' + chips + '</div>' : '',
          '<input class="wwc-cart-upsell-inline__input" data-inline-city type="search" placeholder="' + escapeHtml(T.cityPlaceholder) + '" autocomplete="off">',
          '<div class="wwc-cart-upsell-inline__results" data-inline-city-results></div>'
        ].join('');
      });
    });
  }

  function renderCityResults(results, query) {
    if (!results) return;

    var q = slugify(query || '');

    if (!q || q.length < 2 || !cityCache || !cityCache.length) {
      results.innerHTML = '';
      return;
    }

    var filtered = cityCache.filter(function (item) {
      return (
        slugify(item.plaats).indexOf(q) !== -1 ||
        slugify(item.title).indexOf(q) !== -1 ||
        slugify(item.handle).indexOf(q) !== -1
      );
    }).slice(0, 4);

    results.innerHTML = filtered.map(function (item) {
      return [
        '<button type="button" class="wwc-cart-upsell-inline__city" data-city-choice data-city-name="' + escapeHtml(item.plaats) + '">',
        '<strong>' + escapeHtml(item.plaats) + '</strong>',
        '<span>' + escapeHtml([item.provincie, item.country].filter(Boolean).join(', ')) + '</span>',
        '</button>'
      ].join('');
    }).join('');
  }

  function selectCity(cityBtn) {
    var city = cityBtn.getAttribute('data-city-name') || '';
    var card = cityBtn.closest('[data-wwc-offer-card]');
    if (!card) return;

    var button = card.querySelector('[data-wwc-global-crosssell]');
    var box = card.querySelector('[data-wwc-inline-choice]');

    if (button) button.setAttribute('data-selected-city', city);

    var text = card.querySelector('.wwc-cart-upsell-carousel__content .wwc-cart-upsell-subline, .wwc-tip__tekst .wwc-cart-upsell-subline');   /* WWC ronde 28: ook de rij */

    if (text && text.childNodes[0]) {
      var oldText = text.childNodes[0].textContent || '';
      var base = oldText.indexOf('·') !== -1
        ? oldText.split('·').slice(1).join('·').trim()
        : oldText.replace(/^Kies plaats\s*·\s*/, '');

      text.childNodes[0].textContent = city + ' · ' + base;
    }

    if (box) closeInlineBox(box);
  }

  function submitInlineText(button) {
    var card = button.closest('[data-wwc-offer-card]');
    if (!card) return;

    var addBtn = card.querySelector('[data-wwc-global-crosssell]');
    var textarea = card.querySelector('[data-inline-text]');
    var error = card.querySelector('[data-inline-error]');
    var text = textarea ? (textarea.value || '').trim() : '';

    if (!addBtn) return;

    if (!text) {
      if (error) error.textContent = T.cardTextRequired;
      return;
    }

    addCrossSell(addBtn, {
      handle: addBtn.getAttribute('data-handle'),
      sku: addBtn.getAttribute('data-sku'),
      offerKey: addBtn.getAttribute('data-offer-key'),
      /* Regelnaam-eigenschappen uit de vertaaltabel halen, niet als Nederlandse
         letterlijke tekst. Deze twee namen komen niet alleen in de winkelwagen
         terecht maar reizen mee tot in de bestelling en de orderbevestiging —
         een Franse klant kreeg "Hoort bij: Bestelling" op zijn order. De
         vertalingen stonden er al in alle vier de talen; ze werden alleen niet
         gebruikt. */
      properties: (function () {
        var eigenschappen = {};
        eigenschappen[T.cardTextProperty] = text;
        eigenschappen[T.belongsTo] = T.order;
        return eigenschappen;
      })()
    });
  }

  function toggleAccordion(button, contentSelector) {
    var isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

    var wrap = button.closest('[data-cart-note], [data-cart-discount]');
    var content = wrap ? wrap.querySelector(contentSelector) : null;

    if (content) {
      content.hidden = isOpen;

      if (!isOpen) {
        var input = content.querySelector('input, textarea');
        if (input) setTimeout(function () { input.focus(); }, 60);
      }
    }
  }

  function saveDiscountCode(code) {
    try {
      if (code) sessionStorage.setItem('wwc_discount_code', code);
      else sessionStorage.removeItem('wwc_discount_code');
    } catch (e) {}
  }

  function loadDiscountCode() {
    try {
      return sessionStorage.getItem('wwc_discount_code') || '';
    } catch (e) {
      return '';
    }
  }

  function sanitizeDiscountCode(value) {
    return String(value || '').trim().replace(/\s+/g, '').toUpperCase();
  }

  function setDiscountStatus(status, message, type) {
    if (!status) return;

    status.hidden = !message;
    status.textContent = message || '';
    status.classList.remove('is-success', 'is-error');

    if (type) status.classList.add(type);
  }

  function initDiscountState() {
    var d = drawer();
    if (!d) return;

    var wrap = d.querySelector('[data-cart-discount]');
    if (!wrap) return;

    var input = wrap.querySelector('#CartDiscountDrawer');
    var clear = wrap.querySelector('[data-discount-clear]');
    var status = wrap.querySelector('[data-discount-status]');
    var saved = loadDiscountCode();

    if (input && saved) {
      input.value = saved;
      setDiscountStatus(status, T.discountSavedInit, 'is-success');
    }

    if (clear && input) clear.hidden = !input.value.trim();
  }

  function initTooltips() {
    var d = drawer();
    if (!d) return;

    d.querySelectorAll('[data-wwc-shipping-tooltip]:not([data-wwc-tooltip-ready])').forEach(function (tooltip) {
      tooltip.setAttribute('data-wwc-tooltip-ready', 'true');

      var toggle = tooltip.querySelector('.wwc-shipping-tooltip__toggle');
      var closeBtn = tooltip.querySelector('.wwc-shipping-tooltip__close');

      if (!toggle) return;

      var pinnedOpen = false;

      function openTooltip() {
        tooltip.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }

      function closeTooltip() {
        tooltip.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        pinnedOpen = false;
      }

      toggle.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) openTooltip();
      });

      tooltip.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: hover)').matches && !pinnedOpen) closeTooltip();
      });

      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var isOpen = tooltip.classList.contains('is-open') && pinnedOpen;

        document.querySelectorAll('[data-wwc-shipping-tooltip]').forEach(function (item) {
          item.classList.remove('is-open');

          var btn = item.querySelector('.wwc-shipping-tooltip__toggle');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (isOpen) closeTooltip();
        else {
          pinnedOpen = true;
          openTooltip();
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closeTooltip();
        });
      }

      document.addEventListener('click', function (event) {
        if (!tooltip.contains(event.target)) closeTooltip();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeTooltip();
      });
    });
  }

  function setupObservers() {
    var d = drawer();
    if (!d) return;

    var products = d.querySelector('[data-products]');

    if (products && !products.dataset.wwcObserverReady) {
      products.dataset.wwcObserverReady = 'true';

      var observer = new MutationObserver(function (mutations) {
        if (suppressObserver) return;

        var shouldRender = mutations.some(function (mutation) {
          return Array.prototype.slice.call(mutation.addedNodes || []).some(function (node) {
            return node.nodeType === 1 && !node.hasAttribute('data-wwc-global-upsell');
          });
        });

        if (shouldRender) {
          scheduleRender(120);
          scheduleStaticRefresh();
        }
      });

      observer.observe(products, {
        childList: true,
        subtree: false
      });

      products.addEventListener('scroll', updateScrollHint, { passive: true });


      var scrollArea = d.querySelector('.drawer__scrollable');
      if (scrollArea && !scrollArea.dataset.wwcScrollCueReady) {
        scrollArea.dataset.wwcScrollCueReady = 'true';
        scrollArea.addEventListener('scroll', updateScrollHint, { passive: true });
      }
    }

    if (!window.WWCCartDrawerResizeReady) {
      window.WWCCartDrawerResizeReady = true;
      window.addEventListener('resize', updateScrollHint, { passive: true });
    }
  }

  document.addEventListener('click', function (event) {

    var afterProductsNudge = event.target.closest('[data-wwc-after-products-nudge]');
    if (afterProductsNudge) {
      event.preventDefault();
      event.stopPropagation();

      var d = drawer();
      var scrollArea = d ? d.querySelector('.drawer__scrollable') : null;
      var globalUpsell = d ? d.querySelector('[data-wwc-global-upsell]') : null;
      var note = d ? d.querySelector('[data-cart-note]') : null;
      var discount = d ? d.querySelector('[data-cart-discount]') : null;

      var hasGlobalUpsell = !!(
        globalUpsell &&
        globalUpsell.textContent &&
        globalUpsell.textContent.trim().length > 0
      );

      var target = hasGlobalUpsell ? globalUpsell : (note || discount);

      if (scrollArea && target) {
        var scrollRect = scrollArea.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();

        var top = targetRect.top - scrollRect.top + scrollArea.scrollTop - 12;

        scrollArea.scrollTo({
          top: Math.max(0, top),
          behavior: 'smooth'
        });
      }

      return;
    }

     var serviceHint = event.target.closest('[data-wwc-scroll-service]');
    if (serviceHint) {
      event.preventDefault();
      event.stopPropagation();

      var d = drawer();
      var scrollArea = d ? d.querySelector('.drawer__scrollable') : null;
      var target = d ? (d.querySelector('[data-cart-note]') || d.querySelector('[data-cart-discount]')) : null;

      if (scrollArea && target) {
        scrollArea.scrollTo({
          top: target.offsetTop - 10,
          behavior: 'smooth'
        });
      }

      return;
    }

    
    var footerDiscountInfo = event.target.closest('[data-wwc-footer-discount-info]');
    if (footerDiscountInfo) {
      event.preventDefault();
      event.stopPropagation();

      var note = document.querySelector('[data-wwc-footer-discount-note]');
      if (note) note.hidden = !note.hidden;

      return;
    }

    var removeBtn = event.target.closest('[data-wwc-remove-line]');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      removeCartLine(removeBtn);
      return;
    }

    var noteToggle = event.target.closest('.wwc-cart-note__toggle');
    if (noteToggle) {
      event.preventDefault();
      toggleAccordion(noteToggle, '.wwc-cart-note__content');
      return;
    }

    var discountToggle = event.target.closest('.wwc-cart-discount__toggle');
    if (discountToggle) {
      event.preventDefault();
      toggleAccordion(discountToggle, '.wwc-cart-discount__content');
      return;
    }

    var discountSave = event.target.closest('[data-discount-save]');
    if (discountSave) {
      event.preventDefault();

      var wrap = discountSave.closest('[data-cart-discount]');
      var input = wrap ? wrap.querySelector('#CartDiscountDrawer') : null;
      var clear = wrap ? wrap.querySelector('[data-discount-clear]') : null;
      var status = wrap ? wrap.querySelector('[data-discount-status]') : null;
      var code = sanitizeDiscountCode(input ? input.value : '');

      if (!code) {
        saveDiscountCode('');
        if (input) input.value = '';
        if (clear) clear.hidden = true;
        setDiscountStatus(status, T.discountRequired, 'is-error');
        if (input) input.focus();
        return;
      }

      if (input) input.value = code;
      if (clear) clear.hidden = false;

      saveDiscountCode(code);
      setDiscountStatus(status, T.discountSaved, 'is-success');
      return;
    }

    var discountClear = event.target.closest('[data-discount-clear]');
    if (discountClear) {
      event.preventDefault();

      var discountWrap = discountClear.closest('[data-cart-discount]');
      var discountInput = discountWrap ? discountWrap.querySelector('#CartDiscountDrawer') : null;
      var discountStatus = discountWrap ? discountWrap.querySelector('[data-discount-status]') : null;

      if (discountInput) discountInput.value = '';
      discountClear.hidden = true;
      saveDiscountCode('');
      setDiscountStatus(discountStatus, T.discountRemoved, 'is-success');

      if (discountInput) discountInput.focus();
      return;
    }

    var globalPrev = event.target.closest('[data-wwc-global-prev]');
    if (globalPrev) {
      event.preventDefault();
      event.stopPropagation();

      getCart(false).then(function (cart) {
        var deals = buildGlobalDeals(cart);
        setGlobalIndex(clampGlobalIndex(getGlobalIndex() - 1, deals.length));
        renderGlobalNudges(cart);
      });

      return;
    }

    var globalNext = event.target.closest('[data-wwc-global-next]');
    if (globalNext) {
      event.preventDefault();
      event.stopPropagation();

      getCart(false).then(function (cart) {
        var deals = buildGlobalDeals(cart);
        setGlobalIndex(clampGlobalIndex(getGlobalIndex() + 1, deals.length));
        renderGlobalNudges(cart);
      });

      return;
    }

    var restore = event.target.closest('[data-wwc-restore-offers]');
    if (restore) {
      event.preventDefault();
      event.stopPropagation();

      getCart(false).then(function (cart) {
        var restorableDeals = getRestorableGlobalDeals(cart);

        if (!restorableDeals.length) {
          var box = restore.closest('[data-wwc-global-upsell]');
          if (box) box.innerHTML = '';
          return;
        }

        clearHiddenGlobalOffers();
        clearCartCache();
        scheduleRender(20);
      });

      return;
    }


    var previewBtn = event.target.closest('[data-wwc-preview]');
    if (previewBtn) {
      event.preventDefault();
      event.stopPropagation();

      var previewCard = previewBtn.closest('[data-wwc-offer-card]');
      var preview = previewCard ? previewCard.querySelector('[data-wwc-preview-box]') : null;

      if (preview) preview.hidden = !preview.hidden;
      return;
    }

    var cityBtn = event.target.closest('[data-wwc-change-city]');
    if (cityBtn) {
      event.preventDefault();
      event.stopPropagation();

      var cityCard = cityBtn.closest('[data-wwc-offer-card]');
      var addBtn = cityCard ? cityCard.querySelector('[data-wwc-global-crosssell]') : null;

      if (addBtn) openCityPicker(cityCard, addBtn, false);
      return;
    }

    var cityChoice = event.target.closest('[data-city-choice]');
    if (cityChoice) {
      event.preventDefault();
      event.stopPropagation();
      selectCity(cityChoice);
      return;
    }

    var inlineSubmit = event.target.closest('[data-inline-submit]');
    if (inlineSubmit) {
      event.preventDefault();
      event.stopPropagation();
      submitInlineText(inlineSubmit);
      return;
    }

    var upgradeBtn = event.target.closest('[data-wwc-upgrade]');
    if (upgradeBtn) {
      event.preventDefault();
      event.stopPropagation();
      upgradeLine(upgradeBtn);
      return;
    }

    var itemCross = event.target.closest('[data-wwc-item-crosssell]');
    if (itemCross) {
      event.preventDefault();
      event.stopPropagation();
      openItemCrossSell(itemCross);
      return;
    }

    var globalCross = event.target.closest('[data-wwc-global-crosssell]');
    if (globalCross) {
      event.preventDefault();
      event.stopPropagation();
      openGlobalCrossSell(globalCross);
      return;
    }

    var magnetBtn = event.target.closest('[data-wwc-magnet-action]');
    if (magnetBtn) {
      event.preventDefault();
      event.stopPropagation();

      hideOffer(magnetBtn.getAttribute('data-offer-key'));
      window.location.href = endpoint(WWC.magnetCollectionUrl);
    }
  });

  document.addEventListener('input', function (event) {
    var cityInput = event.target.closest('[data-inline-city]');
    if (cityInput) {
      var box = cityInput.closest('[data-wwc-inline-choice]');
      var results = box ? box.querySelector('[data-inline-city-results]') : null;

      renderCityResults(results, cityInput.value);
      return;
    }

    var discountInput = event.target.closest('#CartDiscountDrawer');
    if (discountInput) {
      var wrap = discountInput.closest('[data-cart-discount]');
      var clear = wrap ? wrap.querySelector('[data-discount-clear]') : null;

      if (clear) clear.hidden = !discountInput.value.trim();
    }
  });

  document.addEventListener('keydown', function (event) {
    var discountInput = event.target.closest('#CartDiscountDrawer');
    if (discountInput && event.key === 'Enter') {
      event.preventDefault();

      var wrap = discountInput.closest('[data-cart-discount]');
      var save = wrap ? wrap.querySelector('[data-discount-save]') : null;

      if (save) save.click();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('#CartDrawerForm');
    if (!form) return;

    if (form.getAttribute('data-wwc-cartdeal-only') === 'true') {
      event.preventDefault();

      var warning = form.querySelector('[data-wwc-cartdeal-only-warning]');
      if (warning) {
        warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
        warning.classList.add('is-shaking');

        setTimeout(function () {
          warning.classList.remove('is-shaking');
        }, 450);
      }

      return;
    }

    var code = sanitizeDiscountCode(loadDiscountCode());
    if (!code) return;

    event.preventDefault();
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });

  function init() {
    if (!drawer()) return;

    setupObservers();
    initTooltips();
    initDiscountState();

    Promise.all([
      loadCities(),
      getCart(true)
    ]).then(function (result) {
      var cart = result[1];

      lastCartSignature = getCartSignature(cart);
      updateCartDrawerStaticParts(cart);
      scheduleRender(20);
    }).catch(function () {
      scheduleRender(20);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart:afterUpdate'].forEach(function (evt) {
    document.addEventListener(evt, function (event) {
      if (event.detail && event.detail.source === 'wwc-cart-drawer') return;

      if (event.detail && event.detail.cart) {
        cartCache = event.detail.cart;
        updateCartDrawerStaticParts(event.detail.cart);
      } else {
        clearCartCache();
        scheduleStaticRefresh();
      }

      scheduleRender(120);
    });
  });
})();